// extensions/easify-options-like/assets/product-options.js
(function () {
  // ===== 捕获 assets 目录 URL（用于动态加载 variant-slides.js）=====
  var currentScript = document.currentScript || (function () {
    var scripts = document.getElementsByTagName("script");
    for (var i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i].src && scripts[i].src.indexOf("product-options.js") !== -1) {
        return scripts[i];
      }
    }
    return null;
  })();
  var __po_assetBase = "";
  if (currentScript && currentScript.src) {
    __po_assetBase = currentScript.src.replace("product-options.js", "");
  }

  // ===== 强力拦截：阻止 Easify 的 cart.js 同步请求及脚本加载 =====
  (function hijackNetwork() {
    // 1. 拦截 Fetch
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] instanceof URL ? arguments[0].href : '');
      if (url.includes('cart.js?app=tpo-fetch') || url.includes('easifyHandleUpdateCart')) {
        console.warn('[TPO] 🧊 Blocked specific Easify cart fetch:', url);
        return new Promise(() => {}); 
      }
      return originalFetch.apply(this, arguments);
    };

    // 2. 拦截 XMLHttpRequest
    const originalXhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      if (typeof url === 'string' && url.includes('cart.js?app=tpo-fetch')) {
        console.warn('[TPO] 🧊 Blocked specific Easify cart XHR:', url);
        this._tpo_blocked = true;
        return; 
      }
      return originalXhrOpen.apply(this, arguments);
    };
    const originalXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      if (this._tpo_blocked) return;
      return originalXhrSend.apply(this, arguments);
    };

    // 3. 拦截脚本注入 (Script Tag Injection)
    const originalCreateElement = document.createElement;
    document.createElement = function(tagName) {
      const el = originalCreateElement.apply(this, arguments);
      if (tagName.toLowerCase() === 'script') {
        const originalSetAttribute = el.setAttribute;
        el.setAttribute = function(name, value) {
          if (name === 'src' && typeof value === 'string' && value.includes('cart.js?app=tpo-fetch')) {
            console.warn('[TPO] 🧊 Blocked Easify script injection:', value);
            return; // 拒绝设置 src
          }
          return originalSetAttribute.apply(this, arguments);
        };
        Object.defineProperty(el, 'src', {
          set: function(value) {
            if (typeof value === 'string' && value.includes('cart.js?app=tpo-fetch')) {
              console.warn('[TPO] 🧊 Blocked Easify script.src setter:', value);
              return;
            }
            this.setAttribute('src', value);
          },
          get: function() { return this.getAttribute('src'); }
        });
      }
      return el;
    };
  })();

    // 用于存放 3D 选择的当前结果
  var current3DSelections = {
    material: null,
    colors: {}, // 按部件存颜色，如 { wheelSpoke: "#FFFFFF", wheelLip: "#000000", ... }
  };

  // 全局 perWheel 价格，每次 onConfirm 事件更新
  var globalPerWheel = 0;
  var globalBasePrice = 0;

  // 全局记录所有加价行为（统一列表，每条记录视为一个 option）
  // 每次 onConfirm 事件会覆盖 3D 相关条目；其他 options 的变更实时追加/更新
  var globalPriceAdditions = {
    // 统一 options 列表，每条格式: { source, label, extraPrice, variants }
    // source: "3d-part-extra" | "3d-gradient" | "3d-tone" | "option-field"
    options: [],
    // 汇总价格字段
    perWheel: 0,
    basePrice: 0,
    perSet: 0
  };

  // 后端 API 基础地址
  var BASE_URL = 'https://pt.rvrnwheel.com/';

  // 全局 3D 定制选择（用于向 cart 提交独立的 properties，兼容原始 Easify 格式）
  var global3DSelections = {};

  // 全局 3D 定制截图 URL（来自 onConfirm 事件的 canvas_url）
  var globalCanvasUrl = '';
  // 全局 3D 定制原始 parts 数据（用于 add2cart 构建 customized* 字段）
  var global3DPartsRaw = [];
  function initProductOptions() {
    var root = document.getElementById("product-options-root");
    if (!root) {

      return;
    }

    // 防止重复初始化
    if (root.__po_initialized) {

      return;
    }
    root.__po_initialized = true;

    var productId = root.getAttribute("data-product-id");
    if (!productId) {

      return;
    }

    // [PO FIX] 立即提取产品变体数据
    (function captureProductData() {
      var productJsonEl = document.getElementById("ProductJson-" + productId);
      if (productJsonEl) {
        try {
          window.__po_variantProduct = JSON.parse(productJsonEl.innerHTML);
        } catch (e) {}
      }
      if (!window.__po_variantProduct) {
        window.__po_variantProduct = window.product || window.Shopify?.product || null;
      }
    })();

    // ===== 尽早绑定 submit 事件（不依赖 API 返回） =====



    // ===== 全局拦截：统一在 document capture 阶段接管 add-to-cart =====
    // 不再依赖同步 DOM 查找（因为 <script> 可能在 <form> 控件之前执行，导致找不到按钮）
    var handleAddToCart = createAddToCartHandler(root, productId);
    // 暴露给外部（如 sticky-add-to-cart）直接触发完整加购（主商品+加价商品批量），
    // 避免通过点击按钮同时触发 halo initAddToCart（纯变体）与 product-options（完整 bundle）造成重复记录。
    window.__po_addToCart = function () {
      handleAddToCart({ target: document.querySelector("form[action*='/cart/add']") || document.querySelector("form[action*='/cart']"), preventDefault: function () {}, stopPropagation: function () {}, stopImmediatePropagation: function () {} });
    };
    var addToCartIntercepted = false; // 防止同一操作被多次处理

    function interceptAddToCart(event, source) {
      if (addToCartIntercepted) {

        return;
      }
      addToCartIntercepted = true;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleAddToCart(event);
      // 重置标记（给 handler 异步执行的机会，下一个事件循环重置）
      setTimeout(function () { addToCartIntercepted = false; }, 500);
    }

    // ===== 全局 click 拦截（capture phase）=====
    // 线上原生 <input type="submit" name="add"> 有 data-btn-addToCart 属性，
    // 主题 JS 可能绑定了 click 事件做 AJAX 加购后跳转 /cart。
    // 必须在 click 阶段就拦截，阻止主题 JS 的后续操作。
    document.addEventListener("click", function (event) {
      var target = event.target;
      // 匹配原生 add-to-cart submit 按钮
      if (target.tagName !== "INPUT") return;
      if (target.type !== "submit") return;
      if (target.name !== "add") return;

      // 排除我们自己渲染的按钮
      if (target.classList.contains("product-options__add-to-cart-btn")) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // 手动触发表单 submit，让它走下面的 submit 拦截器
      var form = target.closest("form");
      if (form) {
        // 用 dispatchEvent 触发 submit（不会触发原生提交，因为下面有 capture 拦截）
        var submitEvent = new Event("submit", { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
      } else {
        // 兜底：直接调用 handler
        interceptAddToCart(event, "click-fallback");
      }
    }, true);

    // ===== 全局 submit 拦截（capture phase）=====
    // 捕获由上面 click handler dispatch 的 submit 事件
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      var action = (form.getAttribute("action") || "").toLowerCase();
      if (action.indexOf("/cart/add") === -1 && action.indexOf("/cart") === -1) return;

      // 检查是否是真正的 add-to-cart 表单（非 drawer、非 installment）
      var hasAddBtn = form.querySelector("button[name='add'], input[name='add']");
      if (!hasAddBtn) {

        return;
      }

      interceptAddToCart(event, "submit");
    }, true); // capture phase

    // ===== 变体选择联动监听：监听隐藏的 select 以同步 globalBasePrice 和 UI =====
    var __po_page_load_time = Date.now();

    // [PO FIX] 尽早提取初始价格，防止 UI 脚本拿到错误的 999 默认值
    (function syncInitialPrice() {
      var selectEl = document.getElementById("product-selectors");
      var urlParams = new URLSearchParams(window.location.search);
      var targetVid = urlParams.get('variant');
      var product = window.__po_variantProduct;

      if (product && product.variants) {
        var matched = null;
        if (targetVid) {
          matched = product.variants.find(function(v) { return String(v.id) === String(targetVid); });
        }
        if (!matched && selectEl && selectEl.value) {
          matched = product.variants.find(function(v) { return String(v.id) === String(selectEl.value); });
        }
        if (!matched && product.variants.length > 0) {
          matched = product.variants[0];
        }

        if (matched) {
          globalBasePrice = (parseFloat(matched.price) / 100.0) || 0;
          window.__po_globalBasePrice = globalBasePrice;

        }
      }
    })();

    function setupVariantLinkage() {
      var selectEl = document.getElementById("product-selectors");
      if (!selectEl) {

        return;
      }

      var updateFromSelect = function(isInitial) {
        var vid = selectEl.value;

        var product = window.__po_variantProduct;
        if (!product || !product.variants) {

          return;
        }
        
        var matched = product.variants.find(function(v) { return String(v.id) === String(vid); });
        if (matched) {
          // --- 启动保护逻辑 ---
          var urlParams = new URLSearchParams(window.location.search);
          var targetVid = urlParams.get('variant');
          
          // 如果是在点击 slide (非初始化)，我们放行更新
          if (!isInitial && Date.now() - __po_page_load_time < 3000) {

          } else if (isInitial && Date.now() - __po_page_load_time < 3000 && targetVid && String(vid) !== String(targetVid)) {

             setTimeout(function() {
                if (selectEl.value !== targetVid) {
                   selectEl.value = targetVid;
                   selectEl.dispatchEvent(new Event('change', { bubbles: true }));
                }
             }, 500);
             return;
          }

          globalBasePrice = (parseFloat(matched.price) / 100.0) || 0;
          globalPriceAdditions.basePrice = globalBasePrice;
          window.__po_globalBasePrice = globalBasePrice; // 暴露给价格 UI 脚本使用

          // 触发价格 UI 脚本立即更新
          document.dispatchEvent(new Event('tpo:price-updated'));
          
          if (typeof window.__po_recalcPrice === "function") {
            window.__po_recalcPrice();
          }
        } else {

        }
      };

      // 允许外部主动调用同步
      window.__po_triggerUpdateFromSelect = function() { updateFromSelect(false); };

      selectEl.addEventListener("change", function() { updateFromSelect(false); });
      // 初始执行一次
      updateFromSelect(true);

      // 强力校准：2秒后再次确认价格是否正确
      setTimeout(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var targetVid = urlParams.get('variant');
        if (targetVid && selectEl.value !== targetVid) {

           selectEl.value = targetVid;
           updateFromSelect(false);
        }
      }, 2000);
    }
    
    // [PO FIX] 尽快执行联动绑定，不再等待 500ms
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupVariantLinkage);
    } else {
      setupVariantLinkage();
    }
    // 同时也保留一个延时作为双保险（应对异步 DOM 注入）
    setTimeout(setupVariantLinkage, 1000);

    // 监听 variant-slide 选中/切换 → 清空 custom_label 控件面板内容
    var vSlideObserver = new MutationObserver(function (mutations) {
      // 如果 pos-3 按钮正在同步选中，跳过清空
      if (root.__po_skipSlideClear) return;
      var hasSlideChange = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          var el = mutation.target;
          if (el.classList.contains("variant-slide-item")) {
            hasSlideChange = true;
          }
        }
      });
      if (hasSlideChange) {
        // [PO FIX] 切变体时：清空并隐藏 design-summary，重新显示默认引导卡片和分隔线
        var dsContainers = document.querySelectorAll('.design-summary[data-po-field-type="custom_label"]');
        dsContainers.forEach(function (c) { c.innerHTML = ""; c.style.display = "none"; });
        var guideCards = document.querySelectorAll('#custom-label-card');
        guideCards.forEach(function (c) { c.style.display = ""; });
        var orDividers = document.querySelectorAll('.or-divider');
        orDividers.forEach(function (c) { c.style.display = ""; });
        // 同时清空全局 3D 定制数据，避免切换变体后残留旧定制
        globalCanvasUrl = "";
        global3DPartsRaw = [];
        global3DSelections = {};
        globalPriceAdditions.options = [];
        globalPerWheel = 0;
        globalPriceAdditions.perWheel = 0;
        globalPriceAdditions.perSet = 0;

      }
    });
    vSlideObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ["class"] });

    // productId='8892840050824';
    var url = BASE_URL + "/api/product-option-set/" + productId;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("Failed to load options");
        return res.json();
      })
      .then(function (data) {

        var optionSet = null;
        var apiProductId = null;
        var baseVarId = null;
        // 新格式：{ product_id, optionSet } 直接返回
        if (data && data.optionSet) {
          apiProductId = data.product_id;
          optionSet = data.optionSet;
          baseVarId = data.base_var_id || null;

        }
        // 兼容旧格式：{ data: { product_id, optionSet } }
        else if (data && data.data && data.data.optionSet) {
          apiProductId = data.data.product_id;
          optionSet = data.data.optionSet;
          baseVarId = data.data.base_var_id || null;

        }

        // 存储 base_var_id 到 root，供 Add to Cart 时回退使用
        if (baseVarId) {
          root.__po_baseVarId = baseVarId;
        }

        // 如果返回的是数组：根据 productId 或 appliesTo === "all" 选择
        if (Array.isArray(data)) {
          optionSet = data.find(function (set) {
            if (Array.isArray(set.productIds) && set.productIds.length > 0) {
              return set.productIds.indexOf(productId) !== -1;
            }
            return false;
          });

          if (optionSet && productId) {
          }

          if (!optionSet) {
            optionSet = data.find(function (set) {
              return set.appliesTo === "all";
            });
            if (optionSet) {
            }
          }

          if (!optionSet && data.length > 0) {
            optionSet = data[0];
          }
        }

        if (!optionSet) {

          return;
        }

        // 如果 fields 中有 button 类型，将 field.id 加上 productId 后缀以确保唯一性
        if (optionSet.fields && Array.isArray(optionSet.fields)) {
          optionSet.fields.forEach(function (field) {
            if (field.type === "button") {
              field.id = field.id + productId;

            }
          });
        }
        // DEBUG: 检查 API 是否返回 type==="variant" 的 field
        if (optionSet.fields && Array.isArray(optionSet.fields)) {
          var variantFields = optionSet.fields.filter(function (f) { return f.type === "variant"; });
          // console.log("[PO Debug] API fields 中 type===variant 的字段数量:", variantFields.length);
          if (variantFields.length === 0) {
            console.warn("[PO Debug] API returned no variant fields! variant-slides will not render!");
          }
        }

        renderOptions(root, optionSet);
        attachPriceAndProperties(root, optionSet);
        scheduleVehicleAutofill(root);   // 用本地车型回填 year/make/model 字段（见下方同名函数）
        // 后台配置了 3D AI Generation URL 且本接口返回 code === 0 → 主图右下角挂「AI Visualize on My Ride」
        mountAiVisualize(root, data);
      })
      .catch(function (err) {

      });
  }

  function sortByPosition(arr) {
    return (arr || []).slice().sort(function (a, b) {
      var pa = a && typeof a.position === "number" ? a.position : 0;
      var pb = b && typeof b.position === "number" ? b.position : 0;
      return pa - pb;
    });
  }

  // 判断元素是否可见（用于价格计算和提交时跳过隐藏字段）
  function isElementVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null && el !== document.body) return false;
    return true;
  }

  // 清空 group 容器内部所有输入项的值/选中状态
  function resetGroupInputs(groupEl) {
    if (!groupEl) return;
    var inputs = groupEl.querySelectorAll("[data-po-field-id]");
    inputs.forEach(function (input) {
      var type = input.getAttribute("data-po-field-type");
      if (type === "text" || type === "textarea") {
        input.value = "";
      } else if (type === "radio" || type === "checkbox") {
        input.checked = false;
      } else if (type === "select") {
        input.value = "";
      } else {
        input.value = "";
      }
    });
  }

  /* ============================================================================
   * 车型回填：本地存储 → 商品选项字段（year / make / model）
   * ----------------------------------------------------------------------------
   * 数据来源与 assets/customer-vehicle.js 是【同一契约】（本模块只读，不写回）：
   *   localStorage['rvrn_customer_vehicle'] = JSON.stringify({
   *     value: "2022 Toyota Camry",   // "year make model"
   *     expiresAt: <时间戳>            // 14 天滚动过期，见 docs/rvrn-dev-guide.html §13.2
   *   })
   *   —— 由 RVRN Wheel Finder 经 rvrn:vehicle-updated 写入。
   *
   * 为什么不能只靠 customer-vehicle.js：那个脚本的匹配规则要求「同一个输入框」里
   * 同时出现 year+make+model，且只认 type=text。本节的字段是【分开的（可能是 select）】，
   * 所以必须在自己的初始化流程里按字段签名逐个回填。
   *
   * 字段识别：按 id / label / placeholder / name 关键字匹配（大小写无关）
   *   · 同时含 year + make + model 的【单个】字段 → 整串写入（如 "Your Year/Make/Model:"）
   *   · 分别含 year / make / model 的独立字段   → 各写对应片段
   *   · 含 wheel / rim / series / style 的 model 字段不认（避开 "Wheel Model" 这类商品字段）
   *
   * 写入策略：
   *   · 只写【空字段】/【字段里只是示例文案】/【上一次由本模块写入过】的字段 —— 用户手填的内容永不覆盖；
   *     字段里是 "E.g., 2023 Porsche 911 GT3 RS" 这类默认文案时（渲染器会带 data-po-default-value，
   *     见 renderOptions 里 is_default 的处理）视为"未填写"，本地有缓存就直接覆盖写入；
   *   · 写入真实值后去掉 .product-options__default-text 的灰色占位样式；
   *   · 按类型处理：text/textarea 走 native setter；select 选中文本匹配的 option；
   *     radio/checkbox 勾选 value/label 匹配项；
   *   · 统一派发 input + change，让面板自身的取值与加价逻辑跟着更新
   *     （提交取值走 collectCurrentSelections()，它从 DOM 读值，所以 DOM 写完即可）。
   *
   * 排查用：控制台可手动调用 window.__po_autofillVehicle()。
   * ========================================================================== */
  var VEHICLE_STORAGE_KEY = "rvrn_customer_vehicle";
  var MULTI_WORD_MAKES = ["alfa romeo", "aston martin", "land rover", "mercedes-benz", "mercedes benz",
                          "rolls-royce", "range rover", "great wall"];

  /** 读取本地车型字符串；无值 / 已过期 / 脏数据都返回空串 */
  function readLocalVehicle() {
    try {
      var raw = localStorage.getItem(VEHICLE_STORAGE_KEY);
      if (!raw) return "";
      var data = JSON.parse(raw);
      if (!data || !data.value) return "";
      if (typeof data.expiresAt === "number" && Date.now() > data.expiresAt) {
        localStorage.removeItem(VEHICLE_STORAGE_KEY);   // 过期即清（与 customer-vehicle.js 同口径）
        return "";
      }
      return String(data.value).trim();
    } catch (e) { return ""; }   // 隐私模式 / 脏数据：静默跳过
  }

  /** "2022 Toyota Camry" → { year, make, model, full }；不足三段返回 null */
  function splitVehicleYMM(value) {
    var parts = String(value || "").trim().split(/\s+/).filter(Boolean);
    if (parts.length < 3) return null;
    var year = parts.shift();
    var rest = parts.join(" ");
    var lower = rest.toLowerCase();
    var make = parts[0];
    var model = parts.slice(1).join(" ");
    for (var i = 0; i < MULTI_WORD_MAKES.length; i++) {
      var m = MULTI_WORD_MAKES[i];
      if (lower.indexOf(m + " ") === 0) {          // 多词品牌优先，如 "Alfa Romeo Giulia"
        make = rest.slice(0, m.length);
        model = rest.slice(m.length).trim();
        break;
      }
    }
    return { year: year, make: make, model: model, full: String(value).trim() };
  }

  function vehicleSignature(field, el) {
    // 关键词池按 dev-guide §13.4 取齐：name / placeholder / aria-label / id（含关联 <label> 文本），
    // 另外并入 app 数据里的 field.label 与 wrapper 内的 <label>（本节的文案实际渲染在这两处）。
    var wrapLabel = "";
    var wrap = el.closest(".product-options__field");
    if (wrap) {
      var labelEl = wrap.querySelector("label");
      if (labelEl) wrapLabel = labelEl.textContent || "";
    }
    return [
      (field && field.id) || el.getAttribute("data-po-field-id") || "",
      (field && field.label) || "",
      wrapLabel,
      el.getAttribute("placeholder") || "",
      el.getAttribute("aria-label") || "",
      el.name || ""
    ].join(" ").toLowerCase();
  }

  /** 该字段承载车型的哪一段：year | make | model | combined | ""（不认） */
  function vehiclePartOfField(field, el) {
    var sig = vehicleSignature(field, el);
    var hasYear = /year|\byr\b/.test(sig);
    var hasMake = /\bmake\b/.test(sig);
    var hasModel = /\bmodel\b/.test(sig);
    if (hasYear && hasMake && hasModel) return "combined";
    if (hasModel && /wheel|rim|series|style/.test(sig)) hasModel = false;  // 商品字段，不是车型字段
    if (hasYear) return "year";
    if (hasMake) return "make";
    if (hasModel) return "model";
    return "";
  }

  /** 车型字段里的"示例/默认文案"（E.g., 2023 Porsche 911 GT3 RS 之类）不是用户真填的车型 */
  var VEHICLE_EXAMPLE_RE = /^\s*(e\.?\s?g\.?|eg|example|ex\.|例|例如)[\s,.:;：，、-]*/i;

  /**
   * 判断一段车型文本是不是"示例/默认文案"而非用户输入：
   *   ① 渲染器把 is_default 的默认文案直接写进 value 时，会同时挂 data-po-default-value（最可靠信号）；
   *   ② 与输入框 placeholder 完全一致；
   *   ③ 与选项集里该字段的 default（非纯数字）完全一致；
   *   ④ 文案本身以 e.g. / example / 例 / 例如 开头。
   * 两处都用它：本地车型回填（autofillVehicleFields）要把这种值当"空"覆盖掉；
   * AI Visualize 提交时要把这种值当"空"提交。
   */
  function vehicleTextIsExample(text, el, field) {
    var value = String(text === undefined || text === null ? "" : text).trim();
    if (!value) return false;

    if (el && el.getAttribute) {
      var def = String(el.getAttribute("data-po-default-value") || "").trim();
      if (def && def === value) return true;
      var placeholder = String(el.getAttribute("placeholder") || "").trim();
      if (placeholder && placeholder === value) return true;
    }
    if (field) {
      var fieldDefault = field.default === undefined || field.default === null ? "" : String(field.default).trim();
      if (fieldDefault && !/^\d+$/.test(fieldDefault) && fieldDefault === value) return true;
    }
    return VEHICLE_EXAMPLE_RE.test(value);
  }

  /* 自派发事件守卫：区分"本模块派发的 input/change"与用户真实操作 */
  var vehicleAutofillGuard = false;
  var VEHICLE_OWNED_ATTR = "data-po-autofilled";

  function dispatchAutofillEvents(el) {
    vehicleAutofillGuard = true;
    try {
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    } finally {
      vehicleAutofillGuard = false;
    }
  }

  function setControlValue(el, value) {
    try {
      var proto = el.tagName === "TEXTAREA"
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
      var setter = Object.getOwnPropertyDescriptor(proto, "value").set;
      setter.call(el, value);
    } catch (e) { el.value = value; }
    dispatchAutofillEvents(el);
  }

  function vehicleValueMatches(text, value) {
    return String(text || "").trim().toLowerCase() === String(value || "").trim().toLowerCase();
  }

  /** 读回"当前值"：select 用【选中项文案】—— el.value 是 option 的 value（如 "toyota"），
   *  与文案不同源，拿来比较会把"我们填过的"误判成"用户填的"。
   *  空 value 视为未选择（下拉的 "Select…" 占位项文案非空，不能当已有值）。 */
  function controlReadBack(el, type) {
    if (type === "select") {
      if (!el.value) return "";
      var o = el.options && el.options[el.selectedIndex];
      return o ? String(o.textContent || "").trim() : "";
    }
    return String(el.value || "").trim();
  }

  /** 把 value 写进单个控件；写入成功返回 true */
  function fillVehicleField(el, type, value) {
    if (!value) return false;

    if (type === "select") {
      var opts = Array.prototype.slice.call(el.options || []);
      var hit = opts.filter(function (o) { return vehicleValueMatches(o.textContent, value); })[0]
             || opts.filter(function (o) { return vehicleValueMatches(o.value, value); })[0]
             || opts.filter(function (o) {
                  return String(o.textContent || "").toLowerCase().indexOf(String(value).toLowerCase()) > -1;
                })[0];
      if (!hit) return false;
      el.value = hit.value;
      dispatchAutofillEvents(el);
      return true;
    }

    if (type === "radio" || type === "checkbox") {
      var label = el.closest("label");
      var text = (el.value || "") + " " + ((label && label.textContent) || "");
      if (!vehicleValueMatches(text, value) && String(text).toLowerCase().indexOf(String(value).toLowerCase()) === -1) return false;
      if (!el.checked) {
        el.checked = true;
        dispatchAutofillEvents(el);
      }
      return true;
    }

    setControlValue(el, value);   // text / textarea / 兜底
    return true;
  }

  /** 用本地车型回填所有匹配字段（幂等，可重复调用）；返回写入的字段数 */
  function autofillVehicleFields(root) {
    var scope = root || document.getElementById("product-options-root");
    if (!scope) return 0;

    var vehicle = readLocalVehicle();
    if (!vehicle) return 0;                       // 本地没有车型 → 一个字段都不动
    if (vehicleTextIsExample(vehicle, null, null)) {
      console.log("[PO] vehicle autofill skipped: 本地缓存里是示例/默认文案 ->", vehicle);
      return 0;                                   // 缓存里存的是示例文案 → 不当车型用
    }
    var ymm = splitVehicleYMM(vehicle);
    if (!ymm) return 0;

    var optionSet = scope.__po_optionSet || null;
    var fields = (optionSet && optionSet.fields) || [];
    var filled = 0;

    scope.querySelectorAll("[data-po-field-id]").forEach(function (el) {
      var type = (el.getAttribute("data-po-field-type") || "").toLowerCase();
      // 只处理真正的输入控件：容器（fieldWrapper）也带 data-po-field-id 但【没有 type】，
      // 必须跳过，否则会把值写到 div 上、还会派发无意义的 change。
      // （collectCurrentSelections 用的就是同一个判据：fieldId 与 type 必须同时存在。）
      if (type !== "text" && type !== "textarea" && type !== "select"
          && type !== "radio" && type !== "checkbox") return;

      var fieldId = el.getAttribute("data-po-field-id");
      var field = fields.filter(function (f) { return f && f.id === fieldId; })[0] || null;
      var part = vehiclePartOfField(field, el);
      if (!part) return;

      // 归属判断用 DOM 标记，不用值比较：见 controlReadBack 的说明
      var owned = el.hasAttribute(VEHICLE_OWNED_ATTR);
      var value = part === "combined" ? ymm.full : ymm[part];
      if (!value) return;

      if (type === "radio" || type === "checkbox") {
        if (el.checked && !owned) return;                 // 用户已选这一项
      } else {
        var current = controlReadBack(el, type);
        // 字段里只是"示例/默认文案"（如 "E.g., 2023 Porsche 911 GT3 RS"）→ 视为空，允许用本地车型覆盖
        var exampleOnly = !!current && vehicleTextIsExample(current, el, field);
        if (current && !owned && !exampleOnly) return;    // 用户手填过 → 永不覆盖
        if (current === value) {                          // 已是目标值：只认领，不重复写入
          el.setAttribute(VEHICLE_OWNED_ATTR, "1");
          el.classList.remove("product-options__default-text");
          return;
        }
      }

      if (fillVehicleField(el, type, value)) {
        el.setAttribute(VEHICLE_OWNED_ATTR, "1");
        el.classList.remove("product-options__default-text");   // 写入真实值：去掉灰色占位样式
        filled++;
      }
    });

    if (filled) {
      console.log("[PO] vehicle autofill -> " + filled + " field(s) from localStorage:",
        ymm.year, ymm.make, ymm.model);
    }
    return filled;
  }

  /** 字段是异步/分批注入的，在几个时间点各试一次（幂等，不会重复覆盖） */
  function scheduleVehicleAutofill(root) {
    [0, 400, 1200, 2500].forEach(function (delay) {
      setTimeout(function () { autofillVehicleFields(root); }, delay);
    });
  }

  // 用户真实输入 → 交还字段归属（此后不再自动覆盖）。忽略本模块自己派发的事件。
  ["input", "change"].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (vehicleAutofillGuard) return;
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute(VEHICLE_OWNED_ATTR)) {
        t.removeAttribute(VEHICLE_OWNED_ATTR);
      }
    }, true);
  });

  // 【不监听 rvrn:vehicle-updated】—— 遵循 dev-guide §13.3：
  // 该事件的唯一消费方是 assets/customer-vehicle.js（负责持久化 + 全站回填），
  // 其它组件应【直接读取 localStorage】，不要自建事件链。
  // 本模块因此只在选项集渲染完成后读本地存储（见上方 scheduleVehicleAutofill）。
  // 若将来 Finder 被嵌进商品页（会出现同页广播），再按 §13.3 的负载格式补：
  //   document.addEventListener('rvrn:vehicle-updated', function (e) {
  //     if (e.detail && e.detail.value) autofillVehicleFields(null, e.detail.value);
  //   });   // 用负载值而不是回读存储，避免与保存顺序产生竞态

  // 排查入口
  window.__po_autofillVehicle = autofillVehicleFields;

  /* ══════════════════════════════════════════════════════════════════════════
   * AI Visualize on My Ride —— 商品主图（a.fancybox）右下角按钮
   *
   * 出现条件（两者同时满足）：
   *   1) 后台（主题设置 → RVRN 3D AI Generation → 3D AI Generation URL）配置了地址，
   *      该值由商品模板写在 #product-options-root[data-ai-visualize-url] 上；空 = 整个功能关闭；
   *      同分组里的 AI Visualize button label 决定按钮文案（留空用默认 "AI Visualize on My Ride"）；
   *   2) /api/product-option-set 请求成功（RuoYi AjaxResult 的 code === 0）。
   *
    * 点击（先看本地标记，再看要不要填表单，最后新标签页打开）：
    *   0) 本地标记 localStorage[rvrn_ai_visualize_<product_id>_<customer_id>]（未登录用 guest）：
    *      · 不存在 → 新建一条 "0"，继续下面的表单流程；
    *      · 值为 "1"（该商品 + 该客户已经提交成功过）→ 跳过表单，直接以同样参数开预览页
    *        （资料取上次提交时缓存的 <key>_lead，字段与首次提交一致；不重复落库/订阅）；
    *      · 值为 "0" → 继续表单流程，提交成功后才改成 "1"。
    *   1) 先弹出产品页的「Let's See It on Your Ride」线索表单
   *      （snippets/rvrn-ride-preview-form.liquid → window.RvrnRidePreviewForm，2026-09-29 从预览页迁来），
   *      预填商品选项里识别到的车型、左卡参考轮毂图、右卡商品名；
   *   2) 用户填完 Name/Email/Phone/Vehicle 点 Continue to AI Preview →
   *      用 <form method="post" target="_blank"> 把下面这套参数 + 表单字段提交到该 URL，
   *      浏览器新开一个标签页承载；取不到的字段提交空串，字段始终齐全；
   *   3) 同时 fire-and-forget 调后端落线索（name/email/phone 的消费者）：
   *      POST {BASE_URL}api/design-review/save（event_type=3）+ /subscribe
   *      （Shopify 订阅 + 客户邮件 + 销售邮件），见下方 aiVisualizePersistLead；
   *   · 表单不可用时（主题没渲染该 snippet）退回第 2 步直接提交、不发线索（那时没有 name/email/phone），
   *     行为与迁移前一致；
   *   · 为什么不是 iframe：目标页（product-ride-preview）要做"强制 Shopify 登录"——
   *     跳 /customer_authentication/login 再带身份回跳，而 Shopify 登录页不允许被 iframe 嵌套，
   *     只有顶层窗口才走得通（如果哪天要回退成内嵌弹窗，改 onAiVisualizeClick 一处即可）。
   *
   * 参数口径（与 product-3d-preview/product-ride-preview.js#normalize 的别名表对齐，
   * 该页 GET 直接用 URL、POST 经 ProductRidePreviewEntryFilter 转成同一套 query）：
   *   · name / email / phone：线索表单的填写值（原样带上，空值也带）；
   *   · vehicle：线索表单里填的完整车辆串（接收端 applyVehicleText 会解析出缺的 year/make/model）；
   *     表单里填的 year/make/model 优先于下面自动识别的值；
   *   · year / make / model：商品选项里识别到的车型字段（vehiclePartOfField）
   *     → localStorage（Wheel Finder 写入的 rvrn_customer_vehicle）兜底；
   *     字段里是"示例/默认文案"（如 "E.g., 2023 Porsche 911 GT3 RS"，渲染器会带 data-po-default-value）
   *     时一律按空串处理，绝不把示例文案当车型提交；
   *   · customer_id：隐藏 input[data-customer-id]（与 getLoggedInCustomerId 同口径，未登录为 ""）；
   *   · img_src    ：被点按钮所在 a.fancybox 里 img 的当前 src（接收端 WHEEL_IMAGE_ALIASES 认 img_src）；
   *   · product_url：当前商品页 origin + pathname；
   *   · product_name：ProductJson 里的商品标题，取不到时退回 .product-title / h1，仍取不到则 ""。
   *
   * 排查用：window.__po_mountAiVisualize() 手动挂按钮、window.__po_aiVisualizeParams() 查看参数。
   * ══════════════════════════════════════════════════════════════════════════ */
  var AI_VISUALIZE_FIELD = {
    year: "year",
    make: "make",
    model: "model",
    customerId: "customer_id",
    image: "img_src",
    productUrl: "product_url",
    productName: "product_name"
  };
  var AI_VISUALIZE_BTN_CLASS = "rvrn-ai-visualize-btn";
  var AI_VISUALIZE_LABEL = "AI Visualize on My Ride";   // 后台没填按钮文案时的兜底
  var AI_VISUALIZE_URL_ATTR = "data-ai-visualize-url";
  var AI_VISUALIZE_LABEL_ATTR = "data-ai-visualize-label";
  /** 表单跳过标记（localStorage）：key = 前缀 + 商品标识 + "_" + customer_id，值 "0" / "1" */
  var AI_VISUALIZE_STORE_PREFIX = "rvrn_ai_visualize_";
  var AI_VISUALIZE_STORE_NEW = "0";        // 点过按钮，表单还没提交成功
  var AI_VISUALIZE_STORE_DONE = "1";       // 提交成功过 → 下次点击跳过表单
  var AI_VISUALIZE_STORE_LEAD_SUFFIX = "_lead";   // 同 key 下缓存本次提交的资料（JSON）

  /**
   * 品牌隔离参数：RVRN 站点固定 brand=rvrn。
   * 预览页（studio.spluxwheels.com）按 hostname 判品牌，该域名默认解析成 SPLUX ——
   * 地址里少了 brand 参数，RVRN 商品页上就会出现 SPLUX 的文案 / 电话 / 邮箱。
   * 这里只在缺失时补，已带 brand=xxx 的原样保留（便于临时切品牌联调）。
   */
  function aiVisualizeWithBrand(url) {
    var value = String(url || "").trim();
    if (!value) return "";
    if (/[?&]brand=/i.test(value)) return value;
    var hash = "";
    var at = value.indexOf("#");
    if (at >= 0) { hash = value.slice(at); value = value.slice(0, at); }
    return value + (value.indexOf("?") >= 0 ? "&" : "?") + "brand=rvrn" + hash;
  }

  /** 后台配置的 3D AI Generation URL（空串 = 功能关闭）；缺失时补 brand=rvrn */
  function aiVisualizeUrl(root) {
    var el = root || document.getElementById("product-options-root");
    var url = el ? el.getAttribute(AI_VISUALIZE_URL_ATTR) : "";
    return aiVisualizeWithBrand(url);
  }

  /** 按钮文案：后台（主题设置）可编辑，留空时用默认文案 */
  function aiVisualizeLabel(root) {
    var el = root || document.getElementById("product-options-root");
    var label = el ? String(el.getAttribute(AI_VISUALIZE_LABEL_ATTR) || "").trim() : "";
    return label || AI_VISUALIZE_LABEL;
  }

  /** RuoYi AjaxResult 业务码；响应里没有 code 字段（数组 / 裸对象等旧格式）视为成功 */
  function aiVisualizeApiCode(data) {
    if (data && !Array.isArray(data) && typeof data === "object" && data.code !== undefined) {
      return Number(data.code);
    }
    return 0;
  }

  /** 商品主图区的 a.fancybox（限定在商品区块的图廊里，避开区块内其它 fancybox） */
  function aiVisualizeAnchors(root) {
    var scope = (root && root.closest && root.closest('[data-section-type="product"]'))
      || document.querySelector('[data-section-type="product"]');
    if (!scope) return [];
    var list = scope.querySelectorAll(".product-img-box a.fancybox");
    if (!list.length) list = scope.querySelectorAll(".product-photos a.fancybox");
    if (!list.length) list = scope.querySelectorAll("a.fancybox");
    return Array.prototype.slice.call(list);
  }

  /** 该 a.fancybox 当前展示的图片地址（lazyload 下 data-src 才是原图，优先取它） */
  function aiVisualizeImageSrc(anchor) {
    if (!anchor) return "";
    var img = anchor.querySelector("img");
    if (!img) return String(anchor.getAttribute("href") || "").trim();
    var src = img.getAttribute("data-src") || img.currentSrc || img.getAttribute("src")
      || img.getAttribute("data-original") || "";
    return String(src).trim();
  }

  /** 车型文本清洗：示例/默认文案一律返回 ""（判定见 vehicleTextIsExample；日志便于产品页控制台核对） */
  function aiVisualizeCleanYmm(text, el, field) {
    var value = String(text === undefined || text === null ? "" : text).trim();
    if (!value) return "";
    if (vehicleTextIsExample(value, el, field)) {
      console.log("[PO] AI Visualize: 车型字段是示例/默认文案，按空串提交 ->", value);
      return "";
    }
    return value;
  }

  /** 当前车型：商品选项里识别到的车型字段优先，localStorage（Wheel Finder）兜底；示例文案一律视为空 */
  function aiVisualizeVehicle(root) {
    var out = { year: "", make: "", model: "" };
    var scope = root || document.getElementById("product-options-root");
    var optionSet = scope && scope.__po_optionSet;
    var fields = (optionSet && optionSet.fields) || [];
    var combined = "";

    if (scope) {
      scope.querySelectorAll("[data-po-field-id]").forEach(function (el) {
        var type = (el.getAttribute("data-po-field-type") || "").toLowerCase();
        if (type !== "text" && type !== "textarea" && type !== "select") return;
        var fieldId = el.getAttribute("data-po-field-id");
        var field = fields.filter(function (f) { return f && f.id === fieldId; })[0] || null;
        var part = vehiclePartOfField(field, el);
        if (!part) return;
        var value = aiVisualizeCleanYmm(controlReadBack(el, type), el, field);
        if (!value) return;   // 空值 / 示例文案（如 "E.g., 2023 Porsche 911 GT3 RS"）→ 不参与拼接
        if (part === "combined") { combined = combined || value; return; }
        out[part] = out[part] || value;
      });
    }

    // 合并字段（"2022 Toyota Camry"）拆成三段补齐；示例文案在上一步已被过滤掉，year/make/model 全为空串
    if (combined && (!out.year || !out.make || !out.model)) {
      var ymm = splitVehicleYMM(combined);
      if (ymm) {
        out.year = out.year || ymm.year;
        out.make = out.make || ymm.make;
        out.model = out.model || ymm.model;
      }
    }

    // 字段里一个都没读到 → 用本地车型（Finder 写入）；本地值是示例文案同样按空处理
    if (!out.year && !out.make && !out.model) {
      var localText = aiVisualizeCleanYmm(readLocalVehicle(), null, null);
      var local = localText ? splitVehicleYMM(localText) : null;
      if (local) { out.year = local.year; out.make = local.make; out.model = local.model; }
    }
    return out;
  }

  /** 商品名：优先 ProductJson 的 title，退回 .product-title / h1 */
  function aiVisualizeProductName() {
    var product = window.__po_variantProduct;
    var name = product && product.title ? String(product.title) : "";
    if (!name) {
      var el = document.querySelector(".product-title") || document.querySelector("h1");
      name = el ? String(el.textContent || "") : "";
    }
    return name.replace(/\s+/g, " ").trim();
  }

  /** 商品链接：当前商品页（去掉 query / hash，避免把变体参数带过去） */
  function aiVisualizeProductUrl() {
    try {
      return window.location.origin + window.location.pathname;
    } catch (e) {
      return (window.location && window.location.href) || "";
    }
  }

  /** 收集提交参数：字段始终齐全，取不到的填空串 */
  function aiVisualizeParams(anchor) {
    var root = document.getElementById("product-options-root");
    var ymm = aiVisualizeVehicle(root);
    var params = {};
    params[AI_VISUALIZE_FIELD.year] = ymm.year;
    params[AI_VISUALIZE_FIELD.make] = ymm.make;
    params[AI_VISUALIZE_FIELD.model] = ymm.model;
    params[AI_VISUALIZE_FIELD.customerId] = getLoggedInCustomerId();
    params[AI_VISUALIZE_FIELD.image] = aiVisualizeImageSrc(anchor);
    params[AI_VISUALIZE_FIELD.productUrl] = aiVisualizeProductUrl();
    params[AI_VISUALIZE_FIELD.productName] = aiVisualizeProductName();
    return params;
  }

  /* ══════════════════════════════════════════════════════════════════════════
   * 表单跳过标记（localStorage）
   *
   *   key   = rvrn_ai_visualize_<product_id>_<customer_id>   （未登录 customer_id 记 guest）
   *   value = "0" 点过按钮、表单还没提交成功   → 再点仍然弹表单
   *           "1" 该商品 + 该客户提交成功过一次 → 再点直接开预览页，跳过表单
   *   <key>_lead = 上次提交的资料（JSON：name/email/phone/vehicle/year/make/model），
   *                跳过表单时用它补齐参数，预览页与后台收到的字段和首次提交一致。
   *
   * 只写浏览器本地：localStorage 不可用（隐私模式 / 配额满 / 被禁用）时静默降级为
   * "每次都弹表单"，不抛异常、不阻断预览页打开。
   * ══════════════════════════════════════════════════════════════════════════ */

  /** 标记 key：商品 id 优先，退回 handle，再退回当前 URL 的最后一段（取不到商品标识则不记录） */
  function aiVisualizeStoreKey(root) {
    var el = root || document.getElementById("product-options-root");
    var productId = "";
    if (el && el.getAttribute) {
      productId = String(el.getAttribute("data-product-id") || "").trim()
        || String(el.getAttribute("data-product-handle") || "").trim();
    }
    if (!productId) {
      try {
        productId = String(window.location.pathname || "").split("/").filter(Boolean).pop() || "";
      } catch (e) { productId = ""; }
    }
    if (!productId) return "";
    return AI_VISUALIZE_STORE_PREFIX + productId + "_" + (getLoggedInCustomerId() || "guest");
  }

  function aiVisualizeStoreRead(key) {
    if (!key) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function aiVisualizeStoreWrite(key, value) {
    if (!key) return false;
    try {
      window.localStorage.setItem(key, String(value));
      return true;
    } catch (e) {
      console.warn("[PO] AI Visualize: 写 localStorage 失败（隐私模式？），本次不记录表单状态:", e);
      return false;
    }
  }

  /** 是否已经提交成功过（值 = "1"）→ 点击时跳过表单 */
  function aiVisualizePreviewed(root) {
    return aiVisualizeStoreRead(aiVisualizeStoreKey(root)) === AI_VISUALIZE_STORE_DONE;
  }

  /** 首次点击：没有记录就建一条 "0"（已有 "1" 不覆盖） */
  function aiVisualizeTouchStore(root) {
    var key = aiVisualizeStoreKey(root);
    if (!key) return;
    if (aiVisualizeStoreRead(key) === null) aiVisualizeStoreWrite(key, AI_VISUALIZE_STORE_NEW);
  }

  /** 提交成功：标记 "1"，并缓存这次提交的资料，供下次跳过表单时复用 */
  function aiVisualizeMarkPreviewed(root, lead) {
    var key = aiVisualizeStoreKey(root);
    if (!key) return;
    aiVisualizeStoreWrite(key, AI_VISUALIZE_STORE_DONE);
    if (lead) aiVisualizeStoreWrite(key + AI_VISUALIZE_STORE_LEAD_SUFFIX, JSON.stringify(lead));
  }

  /** 上次提交的资料（没有 / 解析失败一律返回 {}，由调用方回落到当前识别值） */
  function aiVisualizeCachedLead(root) {
    var key = aiVisualizeStoreKey(root);
    if (!key) return {};
    var raw = aiVisualizeStoreRead(key + AI_VISUALIZE_STORE_LEAD_SUFFIX);
    if (!raw) return {};
    try {
      var data = JSON.parse(raw);
      return (data && typeof data === "object") ? data : {};
    } catch (e) {
      return {};
    }
  }

  /**
   * POST 表单提交（application/x-www-form-urlencoded），target=_blank 在新标签页打开。
   * 用 form 而不是 window.open(url)：参数要随 POST body 提交（图片 URL 很长，不适合挂 query）。
   * @param {string} url
   * @param {Object} params
   */
  function aiVisualizeSubmit(url, params) {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.target = "_blank";
    form.acceptCharset = "UTF-8";
    form.style.display = "none";

    Object.keys(params).forEach(function (name) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = params[name] === undefined || params[name] === null ? "" : String(params[name]);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    try {
      form.submit();
    } finally {
      setTimeout(function () { form.remove(); }, 1000);
    }
  }

  /** 只接受 https:// 地址（后台可填任意值，这里兜一道校验） */
  function aiVisualizeSafeUrl(url) {
    var value = String(url || "").trim();
    return /^https:\/\//i.test(value) ? value : "";
  }

  /**
   * 入口日志用的一行参数摘要：只标出"哪些字段有值"（值本身在随后的对象里可展开看）。
   * 例：year/make/model 空、customer_id ✓、img_src ✓、product_url ✓、product_name ✓
   */
  function aiVisualizeParamsSummary(params) {
    var filled = [];
    var empty = [];
    Object.keys(params).forEach(function (name) {
      (params[name] === "" ? empty : filled).push(name);
    });
    var parts = [];
    if (filled.length) parts.push(filled.join("/") + " ✓");
    if (empty.length) parts.push(empty.join("/") + " 空（等表单填/无数据）");
    return parts.join("，");
  }

  /**
   * 线索表单字段并入 POST 参数（表单填了车型就以表单为准，其余保留自动识别值）：
   *   · name / email / phone：原样带上（字段始终齐全，取不到就是空串）；
   *   · vehicle：车辆串原文 —— 接收端（product-ride-preview.js#applyVehicleText）只补空缺字段，
   *     与下面写死的 year/make/model 不冲突；
   *   · 表单串里解析出的 year/make/model 覆盖自动识别值（用户手填优先于商品选项/本地车型表）。
   */
  function aiVisualizeLeadParams(params, lead) {
    var out = {};
    Object.keys(params).forEach(function (name) { out[name] = params[name]; });
    lead = lead || {};
    out.name = String(lead.name || "");
    out.email = String(lead.email || "");
    out.phone = String(lead.phone || "");
    var vehicle = String(lead.vehicle || "").trim();
    if (vehicle) {
      out.vehicle = vehicle;
      if (lead.year) out[AI_VISUALIZE_FIELD.year] = String(lead.year);
      if (lead.make) out[AI_VISUALIZE_FIELD.make] = String(lead.make);
      if (lead.model) out[AI_VISUALIZE_FIELD.model] = String(lead.model);
    }
    return out;
  }

  /**
   * 跳过表单直接开预览页（标记值 = "1" 的复访点击）。
   * 参数口径与表单提交一致：上次提交的资料优先（缓存的 <key>_lead），缺的字段用当前识别值；
   * 不再重复 /save + /subscribe —— 首次提交时已经落过库、发过邮件，重复发只会多出
   * 线索记录和销售邮件，预览页本身不依赖这两支请求。
   */
  function aiVisualizeDirectPreview(url, params, root) {
    var finalParams = aiVisualizeLeadParams(params, aiVisualizeCachedLead(root));
    console.log("[PO] AI Visualize: 本地标记 = 1（" + aiVisualizeStoreKey(root) + "），跳过表单直接开预览页 -> " + url);
    Object.keys(finalParams).forEach(function (name) {
      console.log("[PO]   " + name + " = " + (finalParams[name] === "" ? "(空)" : finalParams[name]));
    });
    aiVisualizeSubmit(url, finalParams);
  }

  /* ══════════════════════════════════════════════════════════════════════════
   * 线索落库 + 订阅（产品页直接调后端，2026-09-29 随表单一起从预览页接过来）
   *
   * 表单搬到产品页后，原先由预览页 ride-preview-form.js 提交时负责的两支后端调用改由本页发出：
   *   · POST {BASE_URL}api/design-review/save      → wl_design_review 落库，event_type = 3
   *                                                  （preview-rider-design，与预览页时代同一取值）
   *   · POST {BASE_URL}api/design-review/subscribe → 一次调用发布三条 MQ 消息：
   *                                                  Shopify 邮件营销订阅 + 客户订阅邮件 + 销售邮件
   *                                                  （不传 skip_sales_email ⇒ 销售邮件照发，与迁移前一致）
   *
   * 时序：先 aiVisualizeSubmit（新标签页必须在点击手势里同步 submit，否则会被浏览器拦截），
   *       再 fire-and-forget 发这两支请求 —— 失败只打日志，绝不影响预览页打开，
   *       也不阻塞用户（与 RuoYi 侧"订阅失败不阻断出图"的口径一致）。
   *
   * 字段口径（对齐 ruoyi-system DesignReviewEmailService 的 FIELD_DEFS）：
   *   · /subscribe 只发"邮件正文要渲染的 key"（name/email/phone/vehicle/product_name/source/
   *     product_url/screenshot_url）—— 多发的 key 会在两封邮件里多出一行；
   *   · user_id / product_id / event_type 只进 /save（这几个 key 邮件侧已明确不展示）。
   * ══════════════════════════════════════════════════════════════════════════ */

  /** 线索来源标识（写进两封邮件的 Source 行）：沿用预览页时代的取值，便于销售侧按来源连续筛选 */
  var AI_VISUALIZE_LEAD_SOURCE = "product-ride-preview";
  /** wl_design_review.screenshot_url 是 varchar(500)：超长就置空，避免整条落库失败 */
  var AI_VISUALIZE_SHOT_MAX = 500;

  /** POST JSON 到后端（fire-and-forget：任何失败只记日志，返回 {code:-1}） */
  function aiVisualizeJsonPost(path, payload) {
    return fetch(BASE_URL + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // RuoYi AjaxResult：code 0 = 成功。非 0 只记日志（线索失败不影响用户拿到预览页）
        if (!data || Number(data.code) !== 0) {
          console.warn("[PO] AI Visualize: " + path + " 返回非成功码:", data);
        }
        return data || { code: -1 };
      })
      .catch(function (err) {
        console.warn("[PO] AI Visualize: " + path + " 请求失败（不影响预览页打开）:", err);
        return { code: -1 };
      });
  }

  /** 车辆串：表单填的原文优先，没有就用自动识别的三段拼（直接 POST 的兜底路径） */
  function aiVisualizeVehicleText(p) {
    return String(p.vehicle || "").trim()
      || [p[AI_VISUALIZE_FIELD.year], p[AI_VISUALIZE_FIELD.make], p[AI_VISUALIZE_FIELD.model]]
        .filter(Boolean).join(" ").trim();
  }

  /** POST /api/design-review/save：线索落库（含归属 customer_id 与商品信息） */
  function aiVisualizeSaveLead(p, root) {
    var shot = String(p[AI_VISUALIZE_FIELD.image] || "").trim();
    if (shot.length > AI_VISUALIZE_SHOT_MAX) {
      console.warn("[PO] AI Visualize: 参考图 URL 超过 " + AI_VISUALIZE_SHOT_MAX + " 字符（" + shot.length
        + "），screenshot_url 置空后落库");
      shot = "";
    }
    var productId = (root && root.getAttribute) ? String(root.getAttribute("data-product-id") || "") : "";
    var payload = {
      // 归属：登录客户的 Shopify id（未登录为空串，与 getLoggedInCustomerId 同口径）
      user_id: p[AI_VISUALIZE_FIELD.customerId] || "",
      product_id: productId,
      product_name: p[AI_VISUALIZE_FIELD.productName] || "",
      vehicle: aiVisualizeVehicleText(p),
      event_type: 3,
      name: p.name || "",
      phone: p.phone || "",
      email: p.email || "",
      // 参考轮毂图（客户点的那张）＝本次的"设计图"
      screenshot_url: shot,
      product_url: p[AI_VISUALIZE_FIELD.productUrl] || ""
    };
    console.log("[PO] AI Visualize -> POST " + BASE_URL + "api/design-review/save", payload);
    return aiVisualizeJsonPost("api/design-review/save", payload);
  }

  /** POST /api/design-review/subscribe：Shopify 订阅 + 客户邮件 + 销售邮件（只发邮件要渲染的 key） */
  function aiVisualizeSubscribeLead(p) {
    var payload = {
      name: p.name || "",
      email: p.email || "",
      phone: p.phone || "",
      vehicle: aiVisualizeVehicleText(p),
      product_name: p[AI_VISUALIZE_FIELD.productName] || "",
      source: AI_VISUALIZE_LEAD_SOURCE,
      product_url: p[AI_VISUALIZE_FIELD.productUrl] || "",
      screenshot_url: String(p[AI_VISUALIZE_FIELD.image] || "").trim()
    };
    console.log("[PO] AI Visualize -> POST " + BASE_URL + "api/design-review/subscribe", payload);
    return aiVisualizeJsonPost("api/design-review/subscribe", payload);
  }

  /** 落库 + 订阅（并行发出；两支都失败也不影响用户拿到预览页） */
  function aiVisualizePersistLead(p, root) {
    if (!p || !p.email) {
      // 没有邮箱就没有线索可落（订阅接口本身也要求 email）：直接跳过，别制造脏数据
      console.warn("[PO] AI Visualize: 线索缺 email，跳过落库与订阅");
      return;
    }
    return Promise.all([aiVisualizeSaveLead(p, root), aiVisualizeSubscribeLead(p)]);
  }

  /**
   * 按钮点击：capture 阶段拦下，阻断冒泡与默认跳转（避免同时触发 a.fancybox 上的灯箱/缩放）。
   * 先看 localStorage 里的「表单跳过标记」（key = 商品 + customer_id）：
   *   · 没有 → 建一条 "0"，弹线索表单（Let's See It on Your Ride），
   *     提交成功后改成 "1"，以 POST 表单在新标签页打开配置的 URL；
   *   · 等于 "1" → 不再弹表单，直接用上次提交的资料 + 当前参数 POST 开预览页。
   * 表单不可用（主题没渲染 snippets/rvrn-ride-preview-form.liquid）时退回一步 POST，行为不变。
   * 为什么用新标签页而不是 iframe：目标页要做"强制 Shopify 登录"（跳 /customer_authentication/login
   * 再带身份回跳），而 Shopify 登录页不允许被 iframe 嵌套 —— 只有顶层窗口才走得通。
   * 其余流程不变：后台配置有值 + /api/product-option-set 返回 code===0 才挂按钮，参数与取值口径同前。
   */
  function onAiVisualizeClick(event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest("." + AI_VISUALIZE_BTN_CLASS) : null;
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var root = document.getElementById("product-options-root");
    var url = aiVisualizeSafeUrl(aiVisualizeUrl(root));
    if (!url) {
      console.warn("[PO] AI Visualize: URL 必须是 https:// 开头的地址，已放弃打开:", aiVisualizeUrl(root));
      return;
    }
    var anchor = btn.closest("a.fancybox");
    var params = aiVisualizeParams(anchor);

    // 表单跳过标记：没记录 → 先建 "0"（本次表单还没提交成功）；已提交过（"1"）→ 下面跳过表单。
    var previewed = aiVisualizePreviewed(root);
    if (!previewed) aiVisualizeTouchStore(root);

    // GTM 埋点：AI Visualize 按钮点击（命名/写法与 po_customize_button_click 同一套约定）。
    // 必须在这里 push，不能靠 GTM 的「点击」触发器：本监听注册在 document 的 capture 阶段，
    // 上面 stopPropagation() 之后事件不会再冒泡，GTM 挂在 document 上的点击监听收不到。
    // GTM 侧对应「自定义事件」触发器，事件名 ai_visualize_click。
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "ai_visualize_click",
        ai_visualize_url: url,
        ai_visualize_label: aiVisualizeLabel(root),
        product_id: (root && root.getAttribute("data-product-id")) || "",
        product_name: params[AI_VISUALIZE_FIELD.productName] || "",
        product_url: params[AI_VISUALIZE_FIELD.productUrl] || "",
        // 点击这一刻基本为空（车型要顾客在表单里填），提交事件里才有值
        vehicle: [params[AI_VISUALIZE_FIELD.year], params[AI_VISUALIZE_FIELD.make],
          params[AI_VISUALIZE_FIELD.model]].filter(Boolean).join(" "),
        customer_id: params[AI_VISUALIZE_FIELD.customerId] || "",
        // true = 直接开了预览页（跳过线索表单）；false = 弹了表单
        ai_visualize_skip_form: previewed
      });
    } catch (e) { /* 埋点异常不影响主流程 */ }

    // 入口排查日志（点击那一刻 = 弹窗打开那一刻）：只记「基础快照」，一行摘要 + 可展开的对象。
    // 这里 vehicle 通常还是空的 —— 顾客要在表单里填，提交时才有最终车辆数据（见 onSubmit 那条日志）。
    // 摘要的用处：区分"没点过按钮" / "点了但没提交" / "提交了但没成功"。
    var storeKey = aiVisualizeStoreKey(root);
    var storeValue = aiVisualizeStoreRead(storeKey);
    console.log("[PO] AI Visualize: " + (previewed ? "跳过表单直接开预览页" : "open lead form")
      + " -> " + url + "（POST 到该地址）");
    console.log("[PO]   button label = " + aiVisualizeLabel(root));
    console.log("[PO]   表单标记 " + (storeKey || "(无 key，不记录)")
      + " = " + (storeValue === null ? "(无)" : storeValue) + (previewed ? " → 跳过表单" : " → 弹表单"));
    console.log("[PO]   base params 摘要 = " + aiVisualizeParamsSummary(params));
    console.log("[PO]   base params:", params, "| anchor:", anchor);

    // 1) 已提交成功过（标记 = "1"）→ 不弹表单，直接开预览页
    if (previewed) {
      aiVisualizeDirectPreview(url, params, root);
      return;
    }

    // 2) 首次点击（标记 = "0"）→ 弹线索表单（自动识别到的车型作为 Vehicle 预填）
    var formApi = window.RvrnRidePreviewForm;
    if (formApi && typeof formApi.open === "function") {
      var vehicle = [params[AI_VISUALIZE_FIELD.year], params[AI_VISUALIZE_FIELD.make],
        params[AI_VISUALIZE_FIELD.model]].filter(Boolean).join(" ");
      var opened = formApi.open({
        image: params[AI_VISUALIZE_FIELD.image],
        productName: params[AI_VISUALIZE_FIELD.productName],
        vehicle: vehicle,
          // 3) 表单校验通过 → 表单字段并入参数：
          //    a. 先 POST 到目标 URL（target=_blank 新标签页；必须在点击手势里同步 submit）
          //    b. 提交成功 → 本地标记改 "1"（下次点按钮跳过表单）
          //    c. 再 fire-and-forget 落库 + 订阅（/save + /subscribe，失败不影响预览页打开）
          onSubmit: function (lead) {
            var finalParams = aiVisualizeLeadParams(params, lead);
            // 提交排查日志（点 Continue to AI Preview 之后）：这份才是真正 POST 出去的最终参数，
            // 逐条打印便于和后台收到的字段核对（空值标 (空)）。
            console.log("[PO] AI Visualize submit -> POST (new tab) " + url);
            Object.keys(finalParams).forEach(function (name) {
              console.log("[PO]   " + name + " = " + (finalParams[name] === "" ? "(空)" : finalParams[name]));
            });
            console.log("[PO] AI Visualize final params:", finalParams);
            aiVisualizeSubmit(url, finalParams);          // 抛异常 → 表单保持打开，标记不写
            aiVisualizeMarkPreviewed(root, lead);         // 提交成功 → 标记 "1"（下次跳过表单）
            aiVisualizePersistLead(finalParams, root);
          }
      });
      if (opened) return;
      console.warn("[PO] AI Visualize: lead form unavailable, falling back to a direct POST");
    }

    aiVisualizeSubmit(url, params);
  }


  function bindAiVisualizeOnce() {
    if (bindAiVisualizeOnce.__bound) return;
    bindAiVisualizeOnce.__bound = true;
    document.addEventListener("click", onAiVisualizeClick, true);
  }

  /**
   * 挂上按钮（幂等）。
   * @param {HTMLElement} root    #product-options-root
   * @param {*} apiData           /api/product-option-set 的响应体
   * @returns {number} 实际挂上的按钮数（0 = 未配置或接口未成功）
   */
  function mountAiVisualize(root, apiData) {
    var url = aiVisualizeUrl(root);
    if (!url) return 0;                                          // 后台没配置 → 不出现按钮
    if (Number(aiVisualizeApiCode(apiData)) !== 0) return 0;     // 接口没成功 → 不出现按钮
    bindAiVisualizeOnce();

    var mounted = 0;
    var label = aiVisualizeLabel(root);
    aiVisualizeAnchors(root).forEach(function (anchor) {
      if (anchor.querySelector("." + AI_VISUALIZE_BTN_CLASS)) return;   // 已挂过
      // 主题没给 a.fancybox 定位时补上，保证按钮相对主图右下角定位
      try {
        if (window.getComputedStyle(anchor).position === "static") anchor.style.position = "relative";
      } catch (e) { /* noop */ }

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = AI_VISUALIZE_BTN_CLASS;
      btn.textContent = label;
      anchor.appendChild(btn);
      mounted++;
    });

    if (mounted) console.log("[PO] AI Visualize button mounted on " + mounted + " image(s) ->", url, "| label =", label);
    return mounted;
  }

  // 排查入口
  window.__po_mountAiVisualize = mountAiVisualize;
  window.__po_aiVisualizeParams = aiVisualizeParams;
  /** 排查入口：查看当前商品 + 客户的表单跳过标记；传 true 清掉（下次点击重新弹表单） */
  window.__po_aiVisualizeFormMark = function (clear) {
    var root = document.getElementById("product-options-root");
    var key = aiVisualizeStoreKey(root);
    if (clear && key) {
      try {
        window.localStorage.removeItem(key);
        window.localStorage.removeItem(key + AI_VISUALIZE_STORE_LEAD_SUFFIX);
      } catch (e) { /* noop */ }
      return "cleared: " + key;
    }
    return { key: key, value: aiVisualizeStoreRead(key), lead: aiVisualizeCachedLead(root) };
  };
  /** 手动跑一次线索落库 + 订阅（传 aiVisualizeParams() 的输出即可；会真实写库/发信，慎用） */
  window.__po_aiVisualizePersist = aiVisualizePersistLead;

  /**
   * 收集当前所有控件的值及附加价格，用于传给 Customize 弹窗
   * @param {HTMLElement} root
   * @param {Object} optionSet
   * @returns {Array<{name:string, value:string}>}
   */
  function collectCurrentSelections(root, optionSet) {
    var selections = [];
    var selection_define = [];

    var selectionMap = {};
    var fields = optionSet && optionSet.fields ? optionSet.fields : [];


    function findField(fieldId) {
      return fields.find(function (f) {
        return f.id === fieldId;
      });
    }

    function normalizeValue(value) {
      if (value == null) return "";
      return String(value).trim();
    }

    function getEntryKey(fieldId, type) {
      return fieldId + "_" + type;
    }

    function ensureEntry(fieldId, type, name) {
      var key = getEntryKey(fieldId, type);
      if (!selectionMap[key]) {
        selectionMap[key] = {
          name: name,
          value: "",
          _checkedValues: [],
        };
      }

      return selectionMap[key];
    }

    function getChoiceLabel(field, choiceId, fallbackValue) {

      var choice =
        field &&
        field.choices &&
        field.choices.find(function (c) {
          return c.id === choiceId;
        });
      var label = (choice && choice.label) || fallbackValue || "";
      if (choice) {
        var choiceExtraPrice = (choice.variants && choice.variants.extraPrice != null) ? parseFloat(choice.variants.extraPrice) : 0;
        if (choiceExtraPrice > 0) {
          label += " [ +$" + choiceExtraPrice.toFixed(2) + " ]";
        }
      }
      return label;
    }

    var inputs = root.querySelectorAll("[data-po-field-id]");


    inputs.forEach(function (input) {

      if (!isElementVisible(input)) return;

      var fieldId = input.getAttribute("data-po-field-id");
      var type = input.getAttribute("data-po-field-type");
      if (!fieldId || !type) return;

      var field = findField(fieldId);
      var fieldName = field && field.label ? field.label : fieldId;

      if (type === "select") {
        var selectEntry = ensureEntry(fieldId, type, fieldName);

        var selectedOption =
          input.options[input.selectedIndex] || null;

        if (!selectedOption || !input.value) {
          selectEntry.value = "";
          selection_define.push(selectEntry);
          return;
        }

        var selectChoiceId =
          selectedOption.getAttribute("data-po-choice-id") ||
          selectedOption.value;


        selectEntry.value = normalizeValue(
          getChoiceLabel(field, selectChoiceId, selectedOption.textContent || input.value),
        );

        selection_define.push(selectEntry);

        return;
      }

      if (type === "text" || type === "textarea") {
        var textEntry = ensureEntry(fieldId, type, fieldName);
        textEntry.value = normalizeValue(input.value);
        selection_define.push(textEntry);

      } else if (type === "radio") {
        var radioEntry = ensureEntry(fieldId, type, fieldName);
        if (input.checked) {
          radioEntry.value = normalizeValue(
            getChoiceLabel(field, input.getAttribute("data-po-choice-id"), input.value),
          );
          selection_define.push(radioEntry);
        }
      } else if (type === "checkbox") {
        var checkboxEntry = ensureEntry(fieldId, type, fieldName);
        if (input.checked) {
          var checkedValue = normalizeValue(
            getChoiceLabel(field, input.getAttribute("data-po-choice-id"), input.value),
          );
          if (checkedValue && checkboxEntry._checkedValues.indexOf(checkedValue) === -1) {
            checkboxEntry._checkedValues.push(checkedValue);
          }
          selection_define.push(checkboxEntry);
        }
      } else {
        var fallbackEntry = ensureEntry(fieldId, type, fieldName);
        fallbackEntry.value = normalizeValue(input.value);
        selection_define.push(fallbackEntry);
      }
    });

    selections.forEach(function (item) {
      if (Array.isArray(item._checkedValues)) {
        item.value = item._checkedValues.join(", ");
        delete item._checkedValues;
      }
    });

    return selection_define;
  }

  /**
   * 向 3D iframe 页面发送参数控制状态
   */
  function sendToModalViewer(type, payload) {
    var iframe = document.getElementById("3d-viewer-modal-iframe");
    if (iframe && iframe.contentWindow) {
      var data = { type: type };
      for (var key in payload) {
        if (payload.hasOwnProperty(key)) {
          data[key] = payload[key];
        }
      }
      iframe.contentWindow.postMessage(data, "*");
    }
  }

  /**
   * 向 3D iframe（rvrn_v7_new）发送当前产品页面的完整链接
   */
  function sendProductUrlToViewer() {
    if (window.location && window.location.href) {
      sendToModalViewer("PRODUCT_URL", { url: window.location.href });
    }
  }

  /** 主题里承载登录态的隐藏 input（layout/theme.liquid 渲染，全站可用） */
  var CUSTOMER_ID_INPUT_ID = "656565115116111114101";

  /**
   * 登录客户的 Shopify ID —— 全主题统一取值口径，与 assets/rvrn-builder.js#getUserId 一致：
   *   隐藏 input[data-customer-id]（Liquid 注入 customer.id）
   *   → window.__customerId（当前无人赋值，留作兼容）
   * 未登录返回空串；【不】回落到匿名 _shopify_y —— 需要匿名兜底的场景请用 getUserIdentity()。
   * 任何分支取不到值都返回空串：宁可不发，也不发空值。
   */
  function getLoggedInCustomerId() {
    var input = document.getElementById(CUSTOMER_ID_INPUT_ID);
    var id = input && input.getAttribute("data-customer-id");
    if (!id) id = window.__customerId;
    return id ? String(id).trim() : "";
  }

  /**
   * 把登录客户 ID 转发给 3D 配置器 iframe（与 PRODUCT_URL 同一通道）。
   * sendToModalViewer 会把 type 与 payload 合并成 { type: "USER_ID", user_id: "..." }，
   * 即配置器校验所需的形状（按需求约定：接收端支持 user_id / userId，这里用 user_id）。
   */
  function sendCustomerIdToViewer() {
    var customerId = getLoggedInCustomerId();
    if (!customerId) return;
    sendToModalViewer("USER_ID", { user_id: customerId });
  }

  function loadViewerIntoIframe(iframe, viewerUrl) {
    if (!iframe || !viewerUrl) return;

    // 直接加载原始 URL：pt.rvrnwheel.com 已允许嵌入（无 X-Frame-Options，
    // CORS: *），iframe 原生加载在 Safari/Chrome 行为一致。
    // 不再使用 fetch+Blob 中转：blob iframe 的 origin 继承父页面，
    // Safari 对其中 ES module / WebGL / 跨源资源的检查更严格，导致白屏。
    iframe.src = viewerUrl;
  }

  // 监听来自 3D 轮毂页面的 postMessage 消息，并实时在侧边栏渲染
  window.addEventListener("message", function (event) {
    var msg = event.data;
    if (!msg || !msg.type) return;

    var badge = document.querySelector(".product-options__3d-badge");
    if (msg.type === "WHEEL_LOADED") {
      if (badge) {
        badge.textContent = "已加载";
        badge.className = "product-options__3d-badge ready";
      }
    }
    // 材质变更
    if (msg.type === "WHEEL_MATERIAL_CHANGED") {
      var mat = msg.material || "metal";
      current3DSelections.material = mat; // 保存材质到全局状态

      var matText = document.querySelector("[data-po-3d-material]");
      if (matText) {
        matText.textContent = mat;
      }
      return;
    }

    // 颜色/模型变更
    if (msg.type === "WHEEL_COLOR_CHANGED") {
      var part = msg.part || "unknown";
      // 颜色优先，其次 modelPath
      var val = msg.color || msg.modelPath || "(默认)";

      // 保存到全局颜色 map
      current3DSelections.colors[part] = val;

      var modelText = document.querySelector(
        '[data-po-3d-part="' + part + '"]',
      );
      if (modelText) {
        modelText.textContent = val;
      }
      return;
    }
  });

  /**
   * 打开"3D轮毂定制"全尺寸弹窗
   * @param {HTMLElement} root
   * @param {Object} optionSet
   * @param {Array} selections 当前所有控件的值
   */
  function openCustomizeModal(root, optionSet, selections, configuratorUrl, preConfigPayload) {
    // 如果已经存在，就更新定制内容并显示
    var existing = root.querySelector(".product-options__modal-overlay");
    if (existing) {
      existing.classList.remove("is-hidden");
      existing.style.display = "flex";

      // edit3d 复用已有 overlay：向已有 iframe 补发 onPreConfig
      if (preConfigPayload) {
        var existingIframe = existing.querySelector("#3d-viewer-modal-iframe");
        if (existingIframe && existingIframe.contentWindow) {
          setTimeout(function () {
            existingIframe.contentWindow.postMessage({ type: "onPreConfig", data: preConfigPayload }, "*");

          }, 500);
        }
      }
      // 向已有 iframe 补发当前产品完整链接 + 登录客户 ID
      setTimeout(function () {
        sendProductUrlToViewer();
        sendCustomerIdToViewer();
      }, 500);
      return;
    }

    var overlay = document.createElement("div");
    overlay.className = "product-options__modal-overlay";

    var modal = document.createElement("div");
    modal.className = "product-options__modal";

    var appUrl = root.getAttribute("data-app-url");
    if (!appUrl) {
      console.error("[PO] openCustomizeModal: data-app-url is empty, cannot open 3D modal");
      return;
    }

    var appBaseUrl = appUrl.replace(/\/$/, "");

    // 3D 渲染 iframe —— 全窗口覆盖
    var iframe = document.createElement("iframe");
    iframe.id = "3d-viewer-modal-iframe";
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.border = "none";
    iframe.title = "3D Wheel Preview";
    modal.appendChild(iframe);

    var iframeUrl = configuratorUrl || (appBaseUrl + "/api/glb/index_new.html?hidePanel=true");
    loadViewerIntoIframe(iframe, iframeUrl);

    // 向 3D iframe 传入当前产品完整链接（rvrn_v7_new 接收后随表单提交回传）
    // 同时把登录客户 ID 一并送达，供配置器识别当前用户
    iframe.addEventListener("load", function () {
      setTimeout(function () {
        sendProductUrlToViewer();
        sendCustomerIdToViewer();
      }, 1000);
    });

    // edit3DBtn 回传：iframe 加载完成后发送 onPreConfig 恢复上次配置
    if (preConfigPayload) {
      iframe.addEventListener("load", function () {
        setTimeout(function () {
          iframe.contentWindow.postMessage({ type: "onPreConfig", data: preConfigPayload }, "*");

        }, 1000);
      });
    }

    overlay.appendChild(modal);
    root.appendChild(overlay);

    // ========= 隐藏 / 关闭 / 销毁 弹窗 =========

    // 仅隐藏，不销毁 DOM / iframe（给背景点击使用）
    function hideModal() {

      overlay.classList.add("is-hidden");
    }

    // 真正释放资源：清理 iframe、从 DOM 中删除 overlay
    function destroyModal() {

      // 清理 overlay 自己的事件监听
      overlay.removeEventListener("click", hideModal);
      modal.removeEventListener("click", stopModalClickPropagation);

      // 释放 iframe 资源
      if (iframe) {
        iframe.onload = null;
        iframe.src = "about:blank";
      }

      // 从 DOM 删除 overlay
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }

    function stopModalClickPropagation(event) {
      event.stopPropagation();
    }

    // GTM 统计去重状态（挂在 window，避免多次渲染/多实例各自维护独立状态）
    var gtmState = window.__poModalGtm = window.__poModalGtm || { lastKey: null, lastTs: 0 };

    // 独立 GTM 埋点：对同一条 onConfirm/onClose 消息做内容指纹 + 时间窗去重，
    // 同一消息若在 800ms 内重复到达只推一次，且异常绝不阻断主流程。
    // meta 用于 onClose 消息（durationMs/duration 位于消息顶层而非 data 内）
    function pushModalGtm(type, payload, meta) {
      try {
        if (typeof window.dataLayer === "undefined") return;
        var fp = type + "::" + JSON.stringify(payload || {});
        var now = Date.now();
        if (gtmState.lastKey === fp && (now - gtmState.lastTs) < 800) {
          return; // 重复消息，跳过
        }
        gtmState.lastKey = fp;
        gtmState.lastTs = now;

        // 停留时长：onConfirm 在 payload(data) 内，onClose 在消息顶层
        var durationMs = (payload && payload.durationMs) || (meta && meta.durationMs) || null;
        var duration = (payload && payload.duration) || (meta && meta.duration) || null;

        window.dataLayer.push({
          event: type === "onConfirm" ? "customizer_confirm" : "customizer_close",
          customizer_source: root.__po_openSource || "unknown",
          has_canvas: !!globalCanvasUrl,
          parts_count: type === "onConfirm" ? ((payload && payload.parts && payload.parts.length) || 0) : undefined,
          durationMs: durationMs,
          duration: duration,
          timestamp: now
        });
      } catch (gtmErr) {
        /* 埋点异常不影响主流程 */
      }
    }

    // 点击遮罩背景：销毁弹窗
    overlay.addEventListener("click", hideModal);

    // 阻止点击弹窗内容冒泡到 overlay
    modal.addEventListener("click", stopModalClickPropagation);

    // 监听 iframe 的 onConfirm 事件，将 data 渲染到定制信息面板并关闭弹窗
    function handleIframeMessage(event) {
      var msg = event.data;
      if (!msg || !msg.type) return;
      if (msg.type === "onConfirm") {

        // 提取实际数据（msg.data 中包含 parts 和 currentPrices）
        if(msg.data){
          var payload = msg.data || {};

          // 保存 payload 供 edit3DBtn 回传 onPreConfig
          root.__po_last3DPayload = payload;

          // 保存 canvas_url 和原始 parts 数据，供 add2cart 使用
          if (payload.canvas_url) {
            globalCanvasUrl = payload.canvas_url;

          }
          if (payload.parts && Array.isArray(payload.parts)) {
            global3DPartsRaw = payload.parts.slice(); // 浅拷贝，避免引用污染

          }

          // 重置 3D 相关加价记录（保留其他 option-field 来源的条目）
          globalPriceAdditions.options = globalPriceAdditions.options.filter(function (opt) {
            return opt.source === "option-field";
          });
          globalPriceAdditions.perWheel = 0;
          globalPriceAdditions.basePrice = 0;
          globalPriceAdditions.perSet = 0;
          // 重置 3D 选择
          global3DSelections = {};

          // 1. 解析 parts 数组，记录加价行为
          var optionsAddonTotal = 0; // 累计所有 selected options add-on 总额
          if (payload.parts && Array.isArray(payload.parts)) {
            payload.parts.forEach(function (part) {
              var partName = part.partName || "Unknown";
              // 收集 treatment + color 作为细节描述，去掉序号
              var detailFields = [];
              if (part.treatmentId) {
                var treatmentText = String(part.treatmentId).trim().replace(/^\d+\s*\+\s*/, "").replace(/\b\w/g, function(c) { return c.toUpperCase(); });
                if (treatmentText) detailFields.push(treatmentText);
              }
              
              // 处理 gradient 信息

              if (part.gradient) {
                // gradient 为 true 时，优先用 gradColor，否则回退到 part.color
                if (part.gradColor) {
                  detailFields.push(part.gradColor + " (Gradient)");
                } else if (part.color) {
                  var gcText = String(part.color).trim();
                  if (gcText) detailFields.push(gcText + " (Gradient)");
                }
              } else if (part.customColor) {
                // Custom Color：格式 "Custom Color: {Color} ({ColorHex})"，与 design-summary 一致
                var ccPaint = String(part.color || "").trim();
                var ccHex = part.colorHex ? " (" + String(part.colorHex).toUpperCase() + ")" : "";
                detailFields.push("Custom Color: " + (ccPaint || "Custom") + ccHex);
              } else if (part.color) {
                var colorText = String(part.color).trim();
                if (colorText) detailFields.push(colorText);
              }

              var partExtraPrice = (part.extra_price && part.extra_price !== "0.0") ? parseFloat(part.extra_price) : 0;
              // Custom color 加价计入 part 标签（对应 onConfirm msgData 的 custom_color_price）
              if (part.customColor && part.custom_color_price) {
                var ccPrice = parseFloat(part.custom_color_price) || 0;
                if (ccPrice > 0) partExtraPrice += ccPrice;
              }

              // 将 part 选择写入 global3DSelections（用于 cart properties）
              var partLabel = detailFields.join(" + ");
              if (partLabel && partExtraPrice > 0) {
                partLabel += " [ +$" + partExtraPrice.toFixed(2) + " ]";
              }
              if (partLabel) {
                global3DSelections[partName] = partLabel;
              }

              // 记录 extra_price 非零的部件
              if (partExtraPrice > 0) {
                optionsAddonTotal += partExtraPrice;
                var partVars = part.variants || null;
                if (partVars && !partVars.vid) {

                } else if (!partVars) {

                }
                globalPriceAdditions.options.push({
                  source: "3d-part-extra",
                  label: partName + " Extra",
                  extraPrice: partExtraPrice,
                  variants: partVars
                });
              }

              // 通用处理 gradient：如果 gradient 为 true，记录 gradient_extra_price 和 gradient_variants
              if (part.gradient === true) {
                var gradVars = part.gradient_variants || null;
                var gradExtra = part.gradient_extra_price ? parseFloat(part.gradient_extra_price) : 0;
                if (gradExtra > 0) optionsAddonTotal += gradExtra;
                if (gradVars && !gradVars.vid) {

                }
                globalPriceAdditions.options.push({
                  source: "3d-gradient",
                  label: partName + " Gradient",
                  extraPrice: gradExtra,
                  variants: gradVars
                });
                // // 写入 gradient 选择
                // if (part.gradColor) {
                //   var gradLabel = part.gradColor;
                //   if (gradExtra > 0) gradLabel += " [ +$" + gradExtra.toFixed(2) + " ]";
                //   global3DSelections[partName + " Gradient"] = gradLabel;
                // }
              }

              // 处理 custom color：customColor 为 true 时，记录 custom_color_price 和 custom_color_vid
              // 与 design-summary 逐 part 方式一致，避免与汇总 customAdd 重复计入
              if (part.customColor === true) {
                var ccVars = part.custom_color_vid ? { pid: "", vid: String(part.custom_color_vid).replace(/^#/, "") } : null;
                var ccExtra = part.custom_color_price ? parseFloat(part.custom_color_price) : 0;
                if (ccExtra > 0) optionsAddonTotal += ccExtra;
                globalPriceAdditions.options.push({
                  source: "3d-custom-color",
                  label: partName + " Custom Color",
                  extraPrice: ccExtra,
                  variants: ccVars
                });
              }
            });
          }

          // 2. 解析 currentPrices，记录加价行为
          var prices = payload.currentPrices || {};

          // 先处理 toneCount（多色调加价）
          if (prices.toneCount != null) {
            var toneCount = parseInt(prices.toneCount, 10) || 1;
            var toneLabel = "";
            if (toneCount === 1) toneLabel = "Single Color";
            else if (toneCount === 2) toneLabel = "Two-Tone Color";
            else if (toneCount >= 3) toneLabel = "Three-Tone Color";
            var toneAdd = parseFloat(prices.toneAdd) || 0;
            if (toneAdd > 0) optionsAddonTotal += toneAdd;
            if (toneLabel) {
              var toneDisplayLabel = toneLabel;
              if (toneAdd > 0) {
                toneDisplayLabel += " [ +$" + toneAdd.toFixed(2) + " ]";
              }
              global3DSelections["Color Style"] = toneDisplayLabel;
            }
            // 当 toneAdd > 0 时，tone 作为一条特殊的 option 记录
            if (toneAdd > 0) {
              var toneVars = prices.toneVariants || null;
              if (toneVars && !toneVars.vid) {

              } else if (!toneVars) {

              }
              globalPriceAdditions.options.push({
                source: "3d-tone",
                label: "Tone Add",
                extraPrice: toneAdd,
                variants: toneVars
              });
            }
          }

            // 通用遍历 currentPrices 中其余字段，提取 basePrice / perWheel / perSet
          var priceSkipKeys = { toneCount: true, toneAdd: true, toneVariants: true, customAdd: true };
          var basePriceKeys = { basePrice: true, base_price: true };
          var perWheelKeys = { perWheel: true, per_wheel: true };
          var perSetKeys = { perSet: true, per_set: true };

          Object.keys(prices).forEach(function (key) {
            if (priceSkipKeys[key]) return;
            var val = prices[key];
            if (val == null) return;

            // 处理 basePrice / perWheel / perSet（关键全局价格）
            if (basePriceKeys[key]) {
              globalBasePrice = parseFloat(val) || 0;
              globalPriceAdditions.basePrice = globalBasePrice;
              return;
            }
            if (perWheelKeys[key]) {
              globalPerWheel = parseFloat(val) || 0;
              globalPriceAdditions.perWheel = globalPerWheel;
              return;
            }
            if (perSetKeys[key]) {
              var perSet = parseFloat(val) || 0;
              globalPriceAdditions.perSet = perSet;
              return;
            }
          });

          // 3. globalPerWheel 已更新，触发 change 事件让 recalcPrice 重新计算 extra-price
          // recalcPrice 中会自动加上 globalPerWheel

          // 3.5 渲染 design-summary 到 custom_label 容器
          // 先找到 fieldWrapper（初始时 display:none），显示后再创建/更新 dsContainer
          var fieldWrapper = document.querySelector('.product-options__field[data-po-field-id="design-summary"]');
          var dsEl = null;
          if (fieldWrapper) {
            var controlEl = fieldWrapper.querySelector('.product-options__control');
            if (controlEl) {
              // 查找或创建 dsContainer
              dsEl = controlEl.querySelector('.design-summary[data-po-field-type="custom_label"]');
              if (!dsEl) {
                dsEl = document.createElement("div");
                dsEl.className = "design-summary";
                dsEl.id = "design-summary";
                dsEl.setAttribute("data-po-field-id", "design-summary");
                dsEl.setAttribute("data-po-field-type", "custom_label");
                controlEl.appendChild(dsEl);
              }
              // [PO FIX] 取消“打开”逻辑：custom_label 始终可见，此处不再切换可见性
            }
          }
          if (dsEl && payload.parts && Array.isArray(payload.parts)) {
            var specRowsHtml = "";
            var dsAddonTotal = 0;
            payload.parts.forEach(function (part) {
              var partName = part.partName || "Unknown";
              var detailFields = [];
              if (part.treatmentId) {
                var treatmentText = String(part.treatmentId).trim().replace(/^\d+\s*\+\s*/, "").replace(/\b\w/g, function(c) { return c.toUpperCase(); });
                if (treatmentText) detailFields.push(treatmentText);
              }
              if (part.gradient) {
                if (part.gradColor) {
                  detailFields.push(part.gradColor + " (Gradient)");
                } else if (part.color) {
                  var gcText2 = String(part.color).trim();
                  if (gcText2) detailFields.push(gcText2 + " (Gradient)");
                }
              } else if (part.customColor) {
                // Custom Color：格式 "Custom Color: {Color} ({ColorHex})"（对应 onConfirm msgData 的 customColor/color/colorHex）
                var ccPaintName = String(part.color || "").trim();
                var ccHexTag = part.colorHex ? " (" + String(part.colorHex).toUpperCase() + ")" : "";
                detailFields.push("Custom Color: " + (ccPaintName || "Custom") + ccHexTag);
              } else if (part.color) {
                var colorText = String(part.color).trim();
                if (colorText) detailFields.push(colorText);
              }
              var partExtra = (part.extra_price && part.extra_price !== "0.0") ? parseFloat(part.extra_price) : 0;
              if (partExtra == 0 && part.gradient && part.gradient_extra_price) {
                partExtra += parseFloat(part.gradient_extra_price) || 0;
              }
              // Custom color 的加价：计入 part 行加价（对应 onConfirm msgData 的 custom_color_price）
              if (part.customColor && part.custom_color_price) {
                var ccExtra = parseFloat(part.custom_color_price) || 0;
                if (ccExtra > 0) partExtra += ccExtra;
              }
              var priceDisplay = partExtra > 0 ? "+$" + partExtra.toFixed(2) : "Included";
              if (partExtra > 0) dsAddonTotal += partExtra;

              specRowsHtml += '<div class="ds-finish-row"><span class="ds-finish-name">' + partName + ': ' + detailFields.join(" + ") + '</span><span class="ds-finish-price">' + priceDisplay + '</span></div>';
            });

            // 加入 currentPrices 内容到 spec-list
            var pricesForDisplay = payload.currentPrices || {};
            // 处理 tone 信息
            if (pricesForDisplay.toneCount != null) {
              var dispToneCount = parseInt(pricesForDisplay.toneCount, 10) || 1;
              var dispToneLabel = "";
              if (dispToneCount === 1) dispToneLabel = "Single Color";
              else if (dispToneCount === 2) dispToneLabel = "Two-Tone Color";
              else if (dispToneCount >= 3) dispToneLabel = "Three-Tone Color";
              var dispToneAdd = parseFloat(pricesForDisplay.toneAdd) || 0;
              var dispTonePrice = dispToneAdd > 0 ? "+$" + dispToneAdd.toFixed(2) : "Included";
              if (dispToneAdd > 0) dsAddonTotal += dispToneAdd;
              specRowsHtml += '<div class="ds-finish-row"><span class="ds-finish-name">Color Style: ' + dispToneLabel + '</span><span class="ds-finish-price">' + dispTonePrice + '</span></div>';
            }
            // 处理 currentPrices 中其余可能有价格的字段
            // 注：customAdd 已由逐 part 的 custom_color_price 计入（见上方 part 循环），此处跳过避免与 part 行重复显示/累加
            var dispSkipKeys = { toneCount: true, toneAdd: true, toneVariants: true, basePrice: true, base_price: true, perWheel: true, per_wheel: true, perSet: true, per_set: true, finishAdd: true, gradAdd: true, customAdd: true };
            Object.keys(pricesForDisplay).forEach(function (key) {
              if (dispSkipKeys[key]) return;
              var dispVal = parseFloat(pricesForDisplay[key]) || 0;
              if (dispVal > 0) {
                dsAddonTotal += dispVal;
                var dispKeyLabel = key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').replace(/_/g, ' ');
                specRowsHtml += '<div class="ds-finish-row"><span class="ds-finish-name">' + dispKeyLabel + '</span><span class="ds-finish-price">+$' + dispVal.toFixed(2) + '</span></div>';
              }
            });

            // 获取产品名称和基础价格
            var productData = window.__po_variantProduct;
            var productTitle = (productData && productData.title) || "Product";
            var basePrice = globalBasePrice || 0;
            var dsTotal = basePrice + dsAddonTotal;

            var previewHtml = '';
            if (globalCanvasUrl) {
              previewHtml =
                '<div class="summary-preview-wrap">' +
                '  <div class="summary-preview"><img src="' + (BASE_URL + '/' + globalCanvasUrl) + '" alt="Custom 3D finish preview"></div>' +
                '</div>';
            }

            dsEl.innerHTML =
              previewHtml +
              '<div class="ds-section">' +
              '  <div class="ds-section-title">BASE SPECIFICATION</div>' +
              '  <div class="ds-base-row">' +
              '    <span class="ds-base-name">' + productTitle + ' (Base)</span>' +
              '    <span class="ds-base-price">$' + basePrice.toFixed(2) + '</span>' +
              '  </div>' +
              '</div>' +
              '<div class="ds-section">' +
              '  <div class="ds-section-title">SELECTED CUSTOM FINISHES</div>' +
              '  <div class="ds-finish-list">' + specRowsHtml + '</div>' +
              '</div>' +
              '<div class="ds-total-box">' +
              '  <span class="ds-total-label">YOUR CUSTOM FINISH PRICE</span>' +
              '  <span class="ds-total-val"><strong>$' + dsTotal.toFixed(2) + '</strong> / Wheel</span>' +
              '</div>';

            dsEl.style.display = "block";

          }

          // 4. 删除非 renderFieldInput 产生的 customize-wrapper
          var customizeWrappers = document.querySelectorAll(".product-options__customize-wrapper");
          customizeWrappers.forEach(function (wrapper) {
            if (wrapper.parentNode) {
              wrapper.parentNode.removeChild(wrapper);
            }
          });

        }

        destroyModal();

        // onConfirm 为确认消息（payload 内含 durationMs/duration）。
        // 兜底：若旧版 iframe 以无 data 的 onConfirm 表示关闭，仍计入 customizer_close
        if (msg.data) {
          pushModalGtm("onConfirm", payload);
        } else {
          pushModalGtm("onClose", {});
        }
      }

      // onClose：iframe 独立关闭消息，durationMs/duration 位于消息顶层
      if (msg.type === "onClose") {
        destroyModal();
        pushModalGtm("onClose", msg.data || {}, msg);
      }
    }
    window.addEventListener("message", handleIframeMessage);

    overlay.classList.remove("is-hidden");
  }

  /**
   * 打开 3D 定制弹窗（btnEl 和 edit3DBtn 共用入口）
   * @param {HTMLElement} rootEl   product-options-root
   * @param {string}       source  "pos3" | "edit3d"
   * @param {string|null}  configuratorUrl  pos3 传入 field.id，edit3d 从 rootEl.__po_pos3FieldId 取回 field.id
   * @param {Object|null}  preConfigPayload edit3d 传入上次 onConfirm 的 payload
   */
  function handleOpen3DModal(rootEl, source, configuratorUrl, preConfigPayload) {
    // 持久化 configuratorUrl，供后续 edit3d / custom_label 复用
    if (configuratorUrl) {
      rootEl.__po_pos3FieldId = configuratorUrl;
    }

    // pos-3 按钮：根据 base_var_id 在 variant-slides 中选中对应变体
    if (source === "pos3") {
      var baseVid = rootEl.__po_baseVarId;
      if (baseVid) {
        var selectEl = document.getElementById('product-selectors');
        var matchedIdx = -1;
        if (selectEl) {
          for (var ssi = 0; ssi < selectEl.options.length; ssi++) {
            var optVal = String(selectEl.options[ssi].value);
            if (optVal === String(baseVid) || optVal.indexOf(String(baseVid)) !== -1 || String(baseVid).indexOf(optVal) !== -1) {
              matchedIdx = ssi;
              break;
            }
          }
        }
        if (matchedIdx >= 0 && selectEl) {
          rootEl.__po_skipSlideClear = true;

          document.querySelectorAll('.variant-slide-item.is-selected').forEach(function (s) {
            s.classList.remove('is-selected');
          });
          document.querySelectorAll('[data-option-selected-label]').forEach(function (l) {
            l.textContent = '';
          });

          var optionText = selectEl.options[matchedIdx].textContent;
          var parts = optionText.split(' / ');
          document.querySelectorAll('.variant-slides-section').forEach(function (section) {
            var idx = parseInt(section.getAttribute('data-option-index'));
            if (isNaN(idx)) return;
            var value = (parts[idx] || '').trim();
            section.querySelectorAll('.variant-slide-item').forEach(function (item) {
              if (item.getAttribute('data-value') === value) {
                item.classList.add('is-selected');
                var label = section.querySelector('[data-option-selected-label]');
                if (label) label.textContent = value;
              }
            });
          });

          selectEl.selectedIndex = matchedIdx;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));

          rootEl.__po_skipSlideClear = false;

        } else {

        }
      }
    }

    var optSet = rootEl.__po_optionSet;
    var selections = collectCurrentSelections(rootEl, optSet);
    openCustomizeModal(rootEl, optSet, selections, configuratorUrl, preConfigPayload);
  }

  /**
   * 渲染一个字段（既可以用于顶级 field，也可以用于子 field）
   */
  function renderFieldInput(field, childFieldsMap, isChild) {
    var fieldWrapper = document.createElement("div");
    fieldWrapper.className = "product-options__field";

    var type = field.type || "text";

    // 根据 dwidth 设置宽度百分比（dwidth/100）
    var dwidth = parseFloat(field.dwidth) || 100;
    fieldWrapper.setAttribute("data-po-dwidth", dwidth);
    fieldWrapper.style.width = dwidth + "%";
    fieldWrapper.style.paddingRight = (dwidth < 100 ? "8px" : "0");

    if (type !== "button" && type !== "custom_label") {
      var label = document.createElement("label");
      label.className = "product-options__field-label";
      if (field.required === true || field.required === "true") {
        var requiredStar = document.createElement("span");
        requiredStar.className = "product-options__required-star";
        requiredStar.textContent = "*";
        label.appendChild(requiredStar);
      }
      label.appendChild(document.createTextNode(field.label));
      fieldWrapper.appendChild(label);
    }
    // 控件容器，所有控件都放在这里，整体在 label 下面一行
    var controlContainer = document.createElement("div");
    controlContainer.className = "product-options__control";
    controlContainer.style.width = "100%";
    fieldWrapper.appendChild(controlContainer);


    // 文本/文本域
    if (type === "text" || type === "textarea") {
      var input =
        type === "textarea"
          ? document.createElement("textarea")
          : document.createElement("input");
      if (type === "text") input.type = "text";

      input.name = "po_" + field.id;
      input.setAttribute("data-po-field-id", field.id);
      input.setAttribute("data-po-field-type", type);

      // extraPrice：兼容 API 返回的 camelCase (extraPrice) 和 snake_case (extra_price)
      var extraPrice = field.extraPrice != null ? field.extraPrice : field.extra_price;
      if (extraPrice != null) {
        input.setAttribute(
          "data-po-extra-price",
          String(extraPrice),
        );
      }

      // 将 parentChoiceId 写入 data-po-variants.vid，用于加价变体关联
      // （不管是否为子字段，只要有 parentChoiceId 就写入）
      if (field.parentChoiceId) {
        input.setAttribute(
          "data-po-variants",
          JSON.stringify({ vid: field.parentChoiceId }),
        );
      }

      // 处理 is_default: 如果 default 不是纯数字，填入默认文字并带灰度样式
      if (field.is_default === 1 || field.is_default === "1") {
        var defaultVal = field.default || "";
        if (defaultVal && !/^\d+$/.test(String(defaultVal))) {
          input.value = defaultVal;
          input.setAttribute("data-po-default-value", defaultVal);
          input.classList.add("product-options__default-text");
          // 用户聚焦时自动清空默认内容并变为正常颜色
          input.addEventListener("focus", function () {
            if (input.value === defaultVal) {
              input.value = "";
            }
            input.classList.remove("product-options__default-text");
          });
          // 如果失焦时仍为空，恢复默认文字和灰色
          input.addEventListener("blur", function () {
            if (!input.value.trim()) {
              input.value = defaultVal;
              input.classList.add("product-options__default-text");
            }
          });
        } else {
          // 没有有效的默认文字时，也给 text 控件加灰色默认色（表示未填写状态）
          input.classList.add("product-options__default-text");
          input.addEventListener("focus", function () {
            input.classList.remove("product-options__default-text");
          });
          input.addEventListener("blur", function () {
            if (!input.value.trim()) {
              input.classList.add("product-options__default-text");
            }
          });
        }
      } else {
        // 没有 is_default 的 text 控件，默认灰色
        input.classList.add("product-options__default-text");
        input.addEventListener("focus", function () {
          input.classList.remove("product-options__default-text");
        });
        input.addEventListener("blur", function () {
          if (!input.value.trim()) {
            input.classList.add("product-options__default-text");
          }
        });
      }

      controlContainer.appendChild(input);

    // 单选 + 子 group 支持（仅顶级字段生成 group；子字段不再向下嵌套 group）
    } else if (type === "radio" && Array.isArray(field.choices)) {
      var groupName = "po_" + field.id;

      field.choices.forEach(function (choice) {
        var choiceItem = document.createElement("div");
        choiceItem.className = "product-options__choice-item";

        var choiceLabel = document.createElement("label");
        choiceLabel.className = "product-options__choice-label";

        var radio = document.createElement("input");
        radio.type = "radio";
        radio.name = groupName;
        radio.value = choice.value;

        radio.setAttribute("data-po-field-id", field.id);
        radio.setAttribute("data-po-field-type", "radio");
        radio.setAttribute("data-po-choice-id", choice.id);

        // extraPrice 现在在 choice.variants.extraPrice 中
        var choiceExtraPrice = (choice.variants && choice.variants.extraPrice != null) ? parseFloat(choice.variants.extraPrice) : 0;

        if (choiceExtraPrice > 0) {
          radio.setAttribute("data-po-extra-price", String(choiceExtraPrice));
        }

        if (choice.variants) {
          radio.setAttribute("data-po-variants", JSON.stringify(choice.variants));
          if (!choice.variants.vid) {

          }
        } else if (choiceExtraPrice > 0) {

        }

        choiceLabel.appendChild(radio);

        var labelText = " " + choice.label;
        if (choiceExtraPrice > 0) {
          labelText += " (+" + choiceExtraPrice + ")";
        }
        choiceLabel.appendChild(document.createTextNode(labelText));
        choiceItem.appendChild(choiceLabel);

        if (!isChild) {
          var key = field.id + "::" + choice.id;
          var childFields = sortByPosition(childFieldsMap[key] || []);


          if (childFields.length > 0) {
            var groupContainer = document.createElement("div");
            groupContainer.className = "product-options__group-container";
            groupContainer.style.display = "none";
            groupContainer.setAttribute(
              "data-po-group-for-field",
              field.id,
            );
            groupContainer.setAttribute(
              "data-po-group-for-choice",
              choice.id,
            );


            childFields.forEach(function (childField) {
              var childWrapper = renderFieldInput(
                childField,
                childFieldsMap,
                true,
              );
              groupContainer.appendChild(childWrapper);
            });

            choiceItem.appendChild(groupContainer);
          }
        }

        controlContainer.appendChild(choiceItem);
      });

    // 多选
    } else if (
      type === "checkbox" &&
      Array.isArray(field.choices)
    ) {
      var gNameCheckbox = "po_" + field.id;

      field.choices.forEach(function (choice) {
        var choiceItem = document.createElement("div");
        choiceItem.className = "product-options__choice-item";

        var choiceLabel = document.createElement("label");
        choiceLabel.className = "product-options__choice-label";

        var checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.name = gNameCheckbox;
        checkbox.value = choice.value;

        checkbox.setAttribute("data-po-field-id", field.id);
        checkbox.setAttribute("data-po-field-type", "checkbox");
        checkbox.setAttribute("data-po-choice-id", choice.id);

        var choiceExtraPrice = (choice.variants && choice.variants.extraPrice != null) ? parseFloat(choice.variants.extraPrice) : 0;

        if (choiceExtraPrice > 0) {
          checkbox.setAttribute("data-po-extra-price", String(choiceExtraPrice));
        }

        if (choice.variants) {
          checkbox.setAttribute("data-po-variants", JSON.stringify(choice.variants));
          if (!choice.variants.vid) {

          }
        } else if (choiceExtraPrice > 0) {

        }

        choiceLabel.appendChild(checkbox);

        var txtC = " " + choice.label;
        if (choiceExtraPrice > 0) {
          txtC += " (+" + choiceExtraPrice + ")";
        }
        choiceLabel.appendChild(document.createTextNode(txtC));
        choiceItem.appendChild(choiceLabel);

        controlContainer.appendChild(choiceItem);
      });

    // 下拉选择 + 子 group 支持（仅顶级字段生成 group；子字段 select 不再向下递归）
    } else if (
      type === "select" &&
      Array.isArray(field.choices)
    ) {
      var select = document.createElement("select");
      select.name = "po_" + field.id;
      select.setAttribute("data-po-field-id", field.id);
      select.setAttribute("data-po-field-type", "select");

      // 判断 is_default 且 default 是纯数字，则按索引默认选中（从 1 开始）
      var defaultIndex = -1;
      if (field.is_default === 1 || field.is_default === "1") {
        var defaultVal = field.default || "";
        if (/^\d+$/.test(String(defaultVal))) {
          defaultIndex = parseInt(defaultVal, 10);
        }
      }

      // 如果 defaultIndex 为 1（即有 is_default 且 default 为纯数字），不添加占位 option，直接默认选中对应选项
      var hasPlaceholder = !(defaultIndex >= 1 && defaultIndex <= field.choices.length);
      if (hasPlaceholder) {
        var ph2 = document.createElement("option");
        ph2.value = "";
        ph2.textContent = "Please select";
        ph2.disabled = true;
        ph2.selected = true;
        select.appendChild(ph2);
      }

      field.choices.forEach(function (choice, idx) {
        var optEl = document.createElement("option");
        optEl.value = choice.value;
        optEl.textContent = choice.label;

        optEl.setAttribute("data-po-choice-id", choice.id || "");

        // extraPrice 现在在 choice.variants.extraPrice 中
        var choiceExtraPrice = (choice.variants && choice.variants.extraPrice != null) ? parseFloat(choice.variants.extraPrice) : 0;

        if (choiceExtraPrice > 0) {
          optEl.setAttribute("data-po-extra-price", String(choiceExtraPrice));
          optEl.textContent += " (+" + choiceExtraPrice + ")";
        }

        // 如果 defaultIndex 匹配（从1开始），默认选中此选项
        if (defaultIndex === (idx + 1)) {
          optEl.selected = true;
        }

        if (choice.variants) {
          optEl.setAttribute("data-po-variants", JSON.stringify(choice.variants));
          if (!choice.variants.vid) {

          }
        } else if (choiceExtraPrice > 0) {

        }

        select.appendChild(optEl);
      });

      controlContainer.appendChild(select);

      if (!isChild) {
        field.choices.forEach(function (choice) {
          var key = field.id + "::" + choice.id;
          var childFields = sortByPosition(childFieldsMap[key] || []);


          if (childFields.length === 0) {
            return;
          }

          var groupContainerSel = document.createElement("div");
          groupContainerSel.className =
            "product-options__group-container";
          groupContainerSel.style.display = "none";
          groupContainerSel.setAttribute(
            "data-po-group-for-field",
            field.id,
          );
          groupContainerSel.setAttribute(
            "data-po-group-for-choice",
            choice.id,
          );


          childFields.forEach(function (childField) {
            var childWrapper = renderFieldInput(
              childField,
              childFieldsMap,
              true,
            );
            groupContainerSel.appendChild(childWrapper);
          });

          controlContainer.appendChild(groupContainerSel);
        });
      }

    // label 类型：只读文本展示（textarea 实现，高度自适应内容）
    } else if (type === "label") {
      var labelEl = document.createElement("textarea");
      labelEl.name = "po_" + field.id;
      labelEl.setAttribute("data-po-field-id", field.id);
      labelEl.setAttribute("data-po-field-type", "label");
      labelEl.readOnly = true;
      labelEl.rows = 3;
      labelEl.style.resize = "vertical";
      labelEl.style.minHeight = "60px";

      // 如果 is_default 为 1，label 初始值为 "default"，否则为空字符串
      if (field.is_default === 1 || field.is_default === "1") {
        labelEl.value = field.default || "";
      } else {
        labelEl.value = "";
      }

      controlContainer.appendChild(labelEl);

    // button 类型：弹窗按钮
    } else if (type === "button") {
      // [PO FIX] position === 3 的 3D 按钮不再单独渲染，功能已合并到 design-summary 的 edit-3d 中
      if (field.position === 3) {
        // 仅保存 pos3 fieldId 供 design-summary 的 edit-3d 使用
        var rootElForPos3 = document.getElementById("product-options-root");
        if (rootElForPos3) {
          rootElForPos3.__po_pos3FieldId = field.id || null;
        }
        // 不渲染任何可见 DOM；返回一个隐藏的空 wrapper，避免上层 appendChild(undefined) 抛错导致整个 renderOptions 中断
        fieldWrapper.style.display = "none";
        return fieldWrapper;
      }

      var btnEl = document.createElement("button");
      btnEl.type = "button";
      btnEl.className = "product-options__customize-button";
      btnEl.textContent = field.label || field.text || "Open";
      btnEl.setAttribute("data-po-field-id", field.id);
      btnEl.setAttribute("data-po-field-type", "button");

      if (field.id) {
        btnEl.setAttribute("data-po-button-url", field.id);
      }

      btnEl.addEventListener("click", function () {
        var rootEl = document.getElementById("product-options-root");
        if (!rootEl) return;
        var source = "button";

        // GTM 埋点：记录 3D 配置器「Open」按钮点击
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "po_customize_button_click",
            buttonFieldId: field.id || null,
            buttonUrl: field.id || null,
            buttonSource: source,
            buttonPosition: field.position || null,
            buttonText: field.label || field.text || "Open",
            productId: rootEl ? rootEl.getAttribute("data-product-id") : null,
            productHandle: rootEl ? rootEl.getAttribute("data-product-handle") : null
          });
        } catch (e) {}

        handleOpen3DModal(rootEl, source, field.id || null, null);
      });

      controlContainer.appendChild(btnEl);

    // custom_label 类型：[PO FIX] 默认不隐藏，一直显示；取消原先的隐藏逻辑
    } else if (type === "custom_label") {
      // 标记 fieldWrapper 方便 onConfirm / variant-slide 查找
      fieldWrapper.setAttribute("data-po-field-id", field.id);
      // [PO FIX] 不再设置 display:none，custom_label 默认可见
      // 记录 design-summary 字段，供 onConfirm 渲染 label 使用
      var rootElForDs = document.getElementById("product-options-root");
      if (rootElForDs) rootElForDs.__po_dsField = field;

      // 1) OR DESIGN YOUR OWN 分隔线
      var orDivider = document.createElement("div");
      orDivider.className = "or-divider";
      var dividerLabel = field.label || "OR DESIGN YOUR OWN";
      orDivider.innerHTML =
        '<span class="or-divider-line"></span>' +
        '<span class="or-divider-text">' + dividerLabel + '</span>' +
        '<span class="or-divider-line"></span>';

      // 2) 引导卡片（默认状态）
      var guideCard = document.createElement("div");
      guideCard.className = "custom-label-card";
      guideCard.id = "custom-label-card";

      var cardTag = "CUSTOM FINISH STUDIO";
      var cardTitle = field.label || "Build Your Own Finish in 3D";
      var cardDesc = field.default || "";

      guideCard.innerHTML =
        '<div class="cl-card-left">' +
        '  <div class="cl-card-tag">' + cardTag + '</div>' +
        '  <div class="cl-card-title">' + cardTitle + '</div>' +
        '  <div class="cl-card-desc">' + cardDesc + '</div>' +
        '</div>' +
        '<div class="cl-card-right">' +
        '  <button type="button" class="rvrn-btn rvrn-btn--medium open3d-studio" id="open3DStudioBtn">' +
        '    <span class="rvrn-btn__label">OPEN 3D STUDIO</span>' +
        '    <span class="rvrn-btn__arrow" aria-hidden="true">↗</span>' +
        '  </button>' +
        '</div>';

      controlContainer.appendChild(orDivider);
      controlContainer.appendChild(guideCard);

      // 绑定 OPEN 3D STUDIO 按钮点击事件
      var openBtn = guideCard.querySelector("#open3DStudioBtn");
      if (openBtn) {
        openBtn.addEventListener("click", function () {
          var rootEl = document.getElementById("product-options-root");
          if (!rootEl) { console.error("[PO] product-options-root not found"); return; }
          var appUrl = rootEl.getAttribute("data-app-url") || "";
          if (!appUrl) { console.error("[PO] data-app-url missing on product-options-root"); alert("3D Studio URL not configured."); return; }
          var productId = rootEl.getAttribute("data-product-id") || "";
          // 构造 3D 配置器 URL：BASE_URL + parentFieldId + productId
          // parentFieldId 可能自带首尾斜杠（如 /api/glb/configurator/），
          // 合并重复斜杠（保留协议 https:// 后的双斜杠）
          var configUrl = (appUrl.replace(/\/$/, "") + "/" + (field.parentFieldId || "") + "/" + productId)
            .replace(/([^:])\/{2,}/g, "$1/");
          // console.log("[PO] open3DStudio configUrl:", configUrl);
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "po_customize_button_click",
              buttonFieldId: field.id || null,
              buttonSource: "custom_label",
              buttonPosition: field.position || null,
              buttonText: "OPEN 3D STUDIO",
              productId: productId || null,
              productHandle: rootEl ? rootEl.getAttribute("data-product-handle") : null
            });
          } catch (e) {}
          // 兼容两种点击：无编辑记录时传 null 走全新配置，有记录时带回 onConfirm 的 payload
          var editPayload = rootEl.__po_last3DPayload || null;
          handleOpen3DModal(rootEl, "custom_label", configUrl, editPayload);
        });
      } else {
        console.error("[PO] open3DStudioBtn not found in guideCard");
      }

    // 其他未识别类型，兜底 text
    } else {
      var fallback = document.createElement("input");
      fallback.type = "text";
      fallback.name = "po_" + field.id;
      fallback.setAttribute("data-po-field-id", field.id);
      fallback.setAttribute("data-po-field-type", "text");
      controlContainer.appendChild(fallback);
    }

    return fieldWrapper;
  }

  function renderOptions(root, optionSet) {

    // 将 optionSet 存到 root 元素上，供 button 类型字段点击时使用
    root.__po_optionSet = optionSet;

    var container = document.createElement("div");
    container.className = "product-options";

    // ===== 统一合并 variant-slides + customHtmlBlocks + 顶级 fields，按 position 排序 =====
    var unifiedItems = [];

    // [PO FIX] 不再硬编码 variant-slides；改为根据 API fields 中 type==="variant" 的字段动态生成
    (optionSet.customHtmlBlocks || []).forEach(function (block) {
      unifiedItems.push({
        kind: "custom",
        data: block,
        position:
          block && typeof block.position === "number"
            ? block.position
            : 0,
      });
    });

    // DEBUG: 打印所有 field type，定位 label_group 类型检测问题
    var fieldTypeStats = {};
    (optionSet.fields || []).forEach(function (f) {
      var t = (f && f.type) ? f.type : "(undefined)";
      fieldTypeStats[t] = (fieldTypeStats[t] || 0) + 1;
    });
    // console.log("[PO] optionSet.fields 类型分布:", JSON.stringify(fieldTypeStats));
    // console.log("[PO] optionSet.customHtmlBlocks count:", (optionSet.customHtmlBlocks || []).length);

    var hasVariantItem = false;
    (optionSet.fields || []).forEach(function (field) {
      // DEBUG: 打印所有 field type，定位 label_group 类型检测问题
      if (field) {
        // console.log("[PO] field type:", field.type, "| label:", field.label, "| id:", field.id);
      }
      if (field && field.type === "variant") {
        hasVariantItem = true;
        unifiedItems.push({
          kind: "variant",
          data: field,
          position:
            field && typeof field.position === "number"
              ? field.position
              : 2,
        });
      } else if (field && String(field.type).toLowerCase() === "label_group") {
        unifiedItems.push({
          kind: "label_group",
          data: field,
          position:
            field && typeof field.position === "number"
              ? field.position
              : 0,
        });
      } else if (field && String(field.type).toLowerCase() === "label_group_item") {
        // label_group_item 不独立渲染，由其父 label_group 负责渲染
      } else {
        unifiedItems.push({
          kind: "field",
          data: field,
          position:
            field && typeof field.position === "number"
              ? field.position
              : 0,
        });
      }
    });

    unifiedItems.sort(function (a, b) {
      return a.position - b.position;
    });

    // === 预处理：按 parentFieldId/parentChoiceId 归类子字段（group） ===
    var allFields = optionSet.fields || [];

    var childFieldsMap = {}; // key: parentFieldId::parentChoiceId
    allFields.forEach(function (field) {
      if (field.parentFieldId && field.parentChoiceId) {
        var key = field.parentFieldId + "::" + field.parentChoiceId;
        if (!childFieldsMap[key]) childFieldsMap[key] = [];
        childFieldsMap[key].push(field);
      }
    });

    // === 预处理：按 parentFieldId 归类 label_group_item 子项 ===
    var labelGroupItemsMap = {}; // key: parentFieldId (label_group 的 id)
    allFields.forEach(function (field) {
      if (field && String(field.type).toLowerCase() === "label_group_item" && field.parentFieldId) {
        if (!labelGroupItemsMap[field.parentFieldId]) labelGroupItemsMap[field.parentFieldId] = [];
        labelGroupItemsMap[field.parentFieldId].push(field);
      }
    });

    // ===== 渲染 custom blocks 和 fields =====
    // 用于多列布局的行容器
    var currentRow = null;
    var currentRowUsedWidth = 0;
    
    function flushRow() {
      if (currentRow && currentRowUsedWidth > 0) {
        container.appendChild(currentRow);
      }
      currentRow = null;
      currentRowUsedWidth = 0;
    }

    function ensureRow(fieldDwidth) {
      var needWidth = parseFloat(fieldDwidth) || 100;
      // 如果需要100%宽度或者当前行放不下，起新行
      if (needWidth >= 100 || currentRow === null || (currentRowUsedWidth + needWidth) > 100) {
        flushRow();
        currentRow = document.createElement("div");
        currentRow.className = "product-options__row";
        currentRow.style.display = "flex";
        currentRow.style.flexWrap = "wrap";
        currentRow.style.width = "100%";
        currentRowUsedWidth = 0;
      }
    }

    // 收集 want_an_expert 的 position（用于 checkbox 联动）
    var wantExpertPosition = -1;

    unifiedItems.forEach(function (item) {
      if (item.kind === "variant") {
        // 由 Liquid 模板渲染 .variant-slides-section，JS 负责搬进容器并加载交互脚本
        var vField = item.data || {};

        // 1. 注入 CSS
        injectVariantSlidesCSS();

        // 2. 创建容器（宽度由 d_width 控制）
        var dWidth = (vField.d_width != null) ? parseFloat(vField.d_width) : 70;
        var slidesContainer = document.createElement("div");
        slidesContainer.id = "variant-slides-root";
        slidesContainer.className = "product-options__variant-slides";
        slidesContainer.style.width = dWidth + "%";
        slidesContainer.style.margin = "0";
        if (dWidth < 100) {
          slidesContainer.style.marginRight = "3%";
        }
        slidesContainer.style.setProperty('display', 'block', 'important');

        // 3. 尝试从 Liquid 模板渲染的 DOM 中搬入 .variant-slides-section
        var slidesGrid = document.createElement("div");
        slidesGrid.className = "variant-slides-grid";
        var orphanSlides = document.querySelectorAll(".variant-slides-section");
        if (orphanSlides.length > 0) {
          orphanSlides.forEach(function (sec) {
            slidesGrid.appendChild(sec);
            sec.style.display = 'block'; // 取消 CSS 默认隐藏，仅当 product-options 成功时才显示
          });
        }
        slidesContainer.appendChild(slidesGrid);

        // 4. 确保 currentRow 存在
        if (currentRow === null) {
          currentRow = document.createElement("div");
          currentRow.className = "product-options__row";
          currentRow.style.display = "flex";
          currentRow.style.flexWrap = "wrap";
          currentRow.style.width = "100%";
          currentRowUsedWidth = 0;
        }

        currentRow.appendChild(slidesContainer);
        currentRowUsedWidth += dWidth + (dWidth < 100 ? 3 : 0);

        // 5. 动态加载 variant-slides.js
        loadVariantSlidesJS();

        return;
      }

      if (item.kind === "custom") {
        flushRow();
        var block = item.data || {};

        var stepWrapper = document.createElement("div");
        var hasStepLabel = block.stepLabel && block.stepLabel.trim() !== "";
        var isWantExpert = block.id === "want_an_expert";

        // 记录 want_an_expert 的位置
        if (isWantExpert) {
          wantExpertPosition = block.position || 0;
        }

        stepWrapper.className = (hasStepLabel || isWantExpert) ? "product-options__custom-step" : "product-options__custom-step product-options__custom-step--plain";
        // 设置 data-step-label，供 variant-slides 面板联动使用
        if (hasStepLabel) {
          stepWrapper.setAttribute("data-step-label", block.stepLabel.trim());
        } else if (isWantExpert) {
          stepWrapper.setAttribute("data-step-label", "want_an_expert");
        }

        var headerRow = document.createElement("div");
        headerRow.className = "product-options__custom-step-header";

        if (isWantExpert) {
          // want_an_expert: stepLabel 区域渲染为 tpo_radio-buttons-wrapper 风格的 checkbox
          var checkboxId = "po-want-expert-checkbox";
          var wrapper = document.createElement("div");
          wrapper.className = "tpo_radio-buttons-wrapper";

          var cbLabel = document.createElement("label");
          cbLabel.className = "tpo_radio-buttons-label";
          cbLabel.htmlFor = checkboxId;

          var checkbox = document.createElement("input");
          checkbox.type = "checkbox";
          checkbox.id = checkboxId;
          checkbox.className = "tpo_radio-buttons-checkbox";
          checkbox.checked = false; // 默认未选中

          var checkmark = document.createElement("span");
          checkmark.className = "tpo_radio-buttons-checkmark";

          cbLabel.appendChild(checkbox);
          cbLabel.appendChild(checkmark);
          wrapper.appendChild(cbLabel);
          headerRow.appendChild(wrapper);

          // checkbox 联动：选中时显示 > want_an_expert 的面板，否则隐藏
          checkbox.addEventListener("change", function () {
            var isChecked = checkbox.checked;
            // 遍历所有 unifiedItems，找到 position > wantExpertPosition 的面板
            unifiedItems.forEach(function (it) {
              if (it.position <= wantExpertPosition) return;
              var el = it.__po_domElement;
              if (el) {
                el.style.display = isChecked ? "" : "none";
              }
            });
          });
        } else if (hasStepLabel) {
          var stepSpan = document.createElement("span");
          stepSpan.className = "product-options__custom-step-label";
          stepSpan.textContent = block.stepLabel;
          headerRow.appendChild(stepSpan);
        }

        var h3 = document.createElement("h3");
        h3.className = "product-options__custom-step-title";
        h3.textContent = block.title || "";

        if (isWantExpert) {
          wrapper.appendChild(h3);
        } else {
          headerRow.appendChild(h3);
        }
        stepWrapper.appendChild(headerRow);

        if (block.body) {
          var p = document.createElement("p");
          p.className = "product-options__custom-step-body";
          p.textContent = block.body;
          stepWrapper.appendChild(p);
        }

        // 保存 DOM 引用到 item 上，供 checkbox 联动使用
        item.__po_domElement = stepWrapper;

        container.appendChild(stepWrapper);

      } else if (item.kind === "label_group") {
        // === label_group 渲染：横向条幅，含 title/subtitle + 多个 label_group_item 列 ===
        var group = item.data;
        // console.log("[PO] rendering label_group:", group.label, "| id:", group.id, "| items count:", (labelGroupItemsMap[group.id] || []).length);
        if (!group) return;

        var groupDwidth = parseFloat(group.dwidth) || 100;

        if (groupDwidth >= 100) {
          flushRow();
        } else {
          ensureRow(groupDwidth);
        }

        var groupWrapper = document.createElement("div");
        groupWrapper.className = "product-options__label-group";
        if (groupDwidth < 100) {
          groupWrapper.style.width = groupDwidth + "%";
          groupWrapper.style.flexShrink = "0";
        }

        // 标题区
        if (group.label || group.default) {
          var groupHeader = document.createElement("div");
          groupHeader.className = "product-options__label-group-header";
          if (group.label) {
            var groupTitle = document.createElement("h3");
            groupTitle.className = "product-options__label-group-title";
            groupTitle.textContent = group.label;
            groupHeader.appendChild(groupTitle);
          }
          if (group.default) {
            var groupSubtitle = document.createElement("p");
            groupSubtitle.className = "product-options__label-group-subtitle";
            groupSubtitle.textContent = group.default;
            groupHeader.appendChild(groupSubtitle);
          }
          groupWrapper.appendChild(groupHeader);
        }

        // 子项列表
        var items = (labelGroupItemsMap[group.id] || []).slice().sort(function (a, b) {
          return (a.position || 0) - (b.position || 0);
        });

        if (items.length > 0) {
          var itemsRow = document.createElement("div");
          itemsRow.className = "product-options__label-group-items";

          items.forEach(function (it, idx) {
            var itemCol = document.createElement("div");
            itemCol.className = "product-options__label-group-item";

            // label (small uppercase)
            if (it.label) {
              var itemLabel = document.createElement("span");
              itemLabel.className = "product-options__label-group-item-label";
              itemLabel.textContent = it.label;
              itemCol.appendChild(itemLabel);
            }

            // default → subtitle (bold main text)
            if (it.default) {
              var itemText = document.createElement("span");
              itemText.className = "product-options__label-group-item-text";
              itemText.textContent = it.default;
              itemCol.appendChild(itemText);
            }

            itemsRow.appendChild(itemCol);
          });

          groupWrapper.appendChild(itemsRow);
        }

        item.__po_domElement = groupWrapper;

        if (groupDwidth >= 100) {
          container.appendChild(groupWrapper);
        } else {
          currentRow.appendChild(groupWrapper);
          currentRowUsedWidth += groupDwidth;
        }

      } else if (item.kind === "field") {
        var field = item.data;
        if (!field) return;

        if (field.parentFieldId && field.parentChoiceId) {
          return;
        }

        // label_group_item 不独立渲染
        if (String(field.type).toLowerCase() === "label_group_item") {
          return;
        }

        // DEBUG: label_group 类型落入 field 渲染时应告警
        if (String(field.type).toLowerCase() === "label_group") {
          console.error("[PO] BUG: label_group fell through to field rendering!", field);
        }

        var fieldDwidth = parseFloat(field.dwidth) || 100;
        ensureRow(fieldDwidth);

        var fieldWrapper = renderFieldInput(field, childFieldsMap, false);
        currentRow.appendChild(fieldWrapper);
        currentRowUsedWidth += fieldDwidth;

        // 保存 DOM 引用到 item 上，供 want_an_expert checkbox 联动使用
        item.__po_domElement = fieldWrapper;
      }
    });

    flushRow();

    // 保存 want_an_expert 相关状态到 root，供 add-to-cart 验证使用
    root.__po_wantExpertPosition = wantExpertPosition;
    root.__po_unifiedItems = unifiedItems;
    container.__po_unifiedItems = unifiedItems;

    // 初始化：checkbox 默认未选中，隐藏 position > want_an_expert 的面板
    if (wantExpertPosition > -1) {
      unifiedItems.forEach(function (it) {
        if (it.position > wantExpertPosition) {
          var el = it.__po_domElement;
          if (el) {
            el.style.display = "none";
          }
        }
      });
    }

    // ===== 最后渲染附加价格显示块（放在所有容器和按钮的底下） =====
    var extraPriceEl = document.createElement("div");
    extraPriceEl.className = "product-options__extra-price";
    extraPriceEl.textContent = "附加价格：¥0.00";
    container.appendChild(extraPriceEl);

    // 把整体挂到 root
    root.innerHTML = '';
    root.appendChild(container);

  }

  /**
   * 将 FormData（product form 提交）转换为 Shopify /cart/add.js items 数组所需的对象
   * 提取 id / quantity / properties[...]（含 selections 与 tpo_parent_identifier），
   * 并保留 selling_plan / gift_card 等合法字段；忽略 form_type / utf8 / sections 等主题表单字段。
   * @param {FormData} fd
   * @returns {Object}
   */
  function poFormDataToItem(fd) {
    var item = { properties: {} };
    fd.forEach(function (val, key) {
      var k = String(key);
      var pm = k.match(/^properties\[(.+)\]$/);
      if (pm) {
        item.properties[pm[1]] = val;
      } else if (k === "id") {
        item.id = val;
      } else if (k === "quantity") {
        item.quantity = parseInt(val, 10) || 1;
      } else if (k === "selling_plan") {
        item.selling_plan = val;
      } else if (k === "gift_card") {
        item.gift_card = (val === "true" || val === true);
      }
      // 其余主题表单字段（form_type / utf8 / sections / product-id 等）忽略
    });
    if (!Object.keys(item.properties).length) delete item.properties;
    return item;
  }

  /**
   * 回滚购物车：移除本次批量添加中“可能部分成功”的商品。
   * 通过对比添加前的购物车快照（line item key 集合），找出新增的主/加价商品并逐个删除，
   * 保证“严格全部成功才算成功”——只要批量添加整体失败，购物车保持添加前状态。
   * @param {string[]} snapshotKeys 添加前的 line item key 集合
   * @param {string} mainVariantId 主商品变体 ID
   * @param {string[]} extraVariantIds 加价商品变体 ID 列表
   */
  function poRollbackCart(snapshotKeys, mainVariantId, extraVariantIds) {
    var extraSet = {};
    extraVariantIds.forEach(function (vid) { extraSet[String(vid)] = true; });

    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var toRemove = items.filter(function (it) {
          // 新增的行项：key 不在快照中，且变体属于本次提交的主/加价商品
          return snapshotKeys.indexOf(it.key) === -1 &&
                 (String(it.variant_id) === String(mainVariantId) || extraSet[String(it.variant_id)]);
        });

        if (!toRemove.length) {

          return;
        }

        // 串行逐个移除，避免并发修改购物车
        return toRemove.reduce(function (chain, it) {
          return chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ id: it.key, quantity: 0 }),
            });
          });
        }, Promise.resolve());
      });
  }

  /**
   * 从 Cookie 读取指定名称的值
   */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  /**
   * 获取用户唯一标识（登录/未登录通用）
   * - 已登录：使用 Liquid 注入的 customer.id
   * - 未登录：使用 Shopify 内置的 _shopify_y Cookie（长期访客 ID）
   * @returns {string} 用户标识
   */
  function getUserIdentity() {
    // 已登录：真实 customer.id（隐藏 input → window.__customerId）
    // 注：原实现只读 window.__customerId，而主题里没有任何脚本赋值给它，
    //     导致已登录用户也一律回落到匿名 _shopify_y。
    var customerId = getLoggedInCustomerId();

    if (customerId) return customerId;

    // 未登录：使用 Shopify 匿名访客 ID
    return getCookie('_shopify_y') || '';
  }

  /**
   * 构建 /api/wheel/add2cart 请求体
   * 将 product-options 的 selections 和 3D parts 数据映射为 WlCustomAddCart 实体字段
   * @param {Object} selections - field.label → value 的映射
   * @param {string} productId - 产品ID（形参保留：halo.js 的 rvrnAfterAddToCart 按位置传参，删掉会串位；
   *                              请求体里的 productId 字段已改为发送产品完整 URL）
   * @param {string} cartQty - 数量
   */
  function buildWheelAdd2CartPayload(selections, optSetFields, productId, cartQty) {
    var payload = {};

    // ===== 直接映射 =====
    payload.userId = getUserIdentity();

    // 按要求 productId 字段改为发送「产品完整 URL」：后台/邮件侧可直接点回商品页。
    // 口径复用 aiVisualizeProductUrl()（与 product_url 一致）：origin + pathname，
    // 去掉 query/hash，避免把 ?variant= 之类的款式参数当成产品链接送过去。
    payload.productId = aiVisualizeProductUrl();

    // 获取产品名称
    var productData = window.__po_variantProduct;
    payload.productName = (productData && productData.title) || '';

    payload.quantity = parseInt(cartQty, 10) || 1;
    payload.picUrl = globalCanvasUrl || '';

    // ===== customized* 字段：从 3D parts 数据提取 =====
    // 每个 part 的描述格式：treatmentId + " + " + color [+ " + " + gradColor + " (Gradient)"]
    var partFieldMap = {
      'spoke': 'customizedSpoke',
      'barrel': 'customizedBarrel',
      'lip': 'customizedLip',
      'screw': 'customizedScrews',
      'capbg': 'customizedCapBg',
      'caplogo': 'customizedCapLogo'
    };

    // 初始化所有 customized 字段为空字符串
    for (var key in partFieldMap) {
      if (partFieldMap.hasOwnProperty(key)) {
        payload[partFieldMap[key]] = '';
      }
    }

    // 遍历 parts 数组，匹配到对应 customized 字段
    (global3DPartsRaw || []).forEach(function (part) {
      var partName = (part.partName || '').toLowerCase().replace(/[\s\-_]+/g, '');

      // 构建该 part 的描述字符串
      // 格式：
      //   普通颜色    treatment + " + " + color
      //   Custom color treatment + " + " + color + " : " + colorHex + " (custom color)"
      //   Gradient    treatment + " + " + gradColor + " (Gradient)"
      var detailFields = [];
      if (part.treatmentId) {
        var treatmentText = String(part.treatmentId).trim().replace(/^\d+\s*\+\s*/, '');
        if (treatmentText) detailFields.push(treatmentText);
      }

      if (part.customColor === true) {
        var ccColorText = String(part.color || '').trim();
        var ccHexText = part.colorHex ? String(part.colorHex).trim() : '';
        var ccDesc = ccColorText;
        if (ccHexText) ccDesc += ' : ' + ccHexText;
        ccDesc += ' (custom color)';
        if (ccDesc) detailFields.push(ccDesc);
      } else if (part.gradient === true && part.gradColor) {
        detailFields.push(String(part.gradColor).trim() + ' (Gradient)');
      } else if (part.color) {
        var colorText = String(part.color).trim();
        if (colorText) detailFields.push(colorText);
      }

      var partDesc = detailFields.join(' + ');

      // 匹配 customized 字段
      for (var mapKey in partFieldMap) {
        if (partFieldMap.hasOwnProperty(mapKey)) {
          if (partName.indexOf(mapKey) !== -1) {
            payload[partFieldMap[mapKey]] = partDesc;

            break;
          }
        }
      }
    });

    // ===== 构建 field 元数据索引（按 label 查找） =====
    var fieldMetaByLabel = {};
    (optSetFields || []).forEach(function (f) {
      if (f.label) {
        fieldMetaByLabel[f.label.toLowerCase()] = f;
      }
    });

    // ===== 从 selections 匹配其他字段（不区分大小写的关键词匹配） =====
    // 注意：排除以 _ 开头的 key（如 _Diameter_variant_id），避免匹配到 variant ID
    var selectionLabels = {};
    for (var k in selections) {
      if (selections.hasOwnProperty(k) && k.charAt(0) !== '_') {
        selectionLabels[k.toLowerCase()] = selections[k];
      }
    }

    /**
     * 检查字段值是否为默认值（required + default 场景应返回空字符串）
     * @param {string} resolvedLabel - 匹配到的 selections key 的原始大小写
     * @param {string} rawValue - 匹配到的原始值
     * @returns {string} 清理后的值
     */
    function cleanFieldValue(resolvedLabel, rawValue) {
      var meta = fieldMetaByLabel[resolvedLabel.toLowerCase()];
      if (!meta) return rawValue;
      // required===true 且值为默认内容 → 返回空字符串
      var isRequired = meta.required === true || meta.required === 'true';
      if (!isRequired) return rawValue;
      var defaultVal = meta.default || '';
      var trimmed = String(rawValue).trim();
      if (trimmed === String(defaultVal) || String(defaultVal).indexOf(trimmed) !== -1) {

        return '';
      }
      return rawValue;
    }

    // 辅助函数：遍历 selectionLabels 找到包含 keyword 的 key 对应的值
    function findSelectionValue(keywords) {
      for (var i = 0; i < keywords.length; i++) {
        var kw = keywords[i].toLowerCase();
        for (var label in selectionLabels) {
          if (selectionLabels.hasOwnProperty(label) && label.indexOf(kw) !== -1) {
            return cleanFieldValue(label, selectionLabels[label]);
          }
        }
      }
      return '';
    }

    payload.wheelPosition = findSelectionValue(['position', '安装位置', 'wheel position']);
    payload.diameter = findSelectionValue(['diameter', '直径']);
    payload.width = findSelectionValue(['width', '宽度']);
    payload.make = findSelectionValue(['make', '品牌', '车型']);
    payload.fitmentStyle = findSelectionValue(['fitment', '风格', '适配']);
    payload.brakeType = findSelectionValue(['brake', '刹车']);
    payload.suspensionSetup = findSelectionValue(['suspension', '悬挂']);
    payload.pcdCbEt = findSelectionValue(['pcd', 'cb', 'et']);
    payload.capStyle = findSelectionValue(['cap style', 'capstyle', '轮毂盖款式']);
    payload.emblem = findSelectionValue(['emblem', '徽章']);
    payload.personalEngravings = findSelectionValue(['engrav', '雕刻']);
    payload.notes = findSelectionValue(['note', '备注']);
    payload.name = findSelectionValue(['name', '姓名', '联系人']);
    payload.phone = findSelectionValue(['phone', '电话', 'mobile']);
    payload.email = findSelectionValue(['email', '邮箱']);
    payload.message = findSelectionValue(['message', '留言']);

    return payload;
  }

  /**
   * 发送加购数据到后端 /api/wheel/add2cart（fire-and-forget）
   */
  function sendWheelAdd2Cart(selections, optSetFields, productId, cartQty) {
    var payload = buildWheelAdd2CartPayload(selections, optSetFields, productId, cartQty);

    var url = BASE_URL + '/api/wheel/add2cart';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {

      return res.json();
    }).then(function (data) {

    }).catch(function (err) {

    });
  }
  // 暴露给全局，供 halo.js 的 rvrnAfterAddToCart 在 product-options 上下文调用
  window.sendWheelAdd2Cart = sendWheelAdd2Cart;

  /**
   * 兜底：找不到表单时，监听按钮点击触发自定义 add-to-cart
   * 注意：全局 submit 拦截已在 initProductOptions 中设置，这里只做按钮级别的额外拦截
   */
  function tryBindAddToCartButtons(root, productId) {
    var handleAddToCart = createAddToCartHandler(root, productId);

    // 监听页面上的 add-to-cart 按钮点击（capture phase）
    document.addEventListener("click", function (event) {
      var target = event.target;
      var btn = target.closest("button[name='add'], button[type='submit'], .product-form__submit, [data-testid='Checkout-button']");
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      handleAddToCart(event);
    }, true); // capture phase to intercept before Shopify's own handlers

    // 也监听表单提交（以防后续 DOM 变化后表单出现）
    var observer = new MutationObserver(function () {
      var form = document.querySelector("form[action*='/cart/add']") || document.querySelector("form[action*='/cart']");
      if (form && !form.__poBound) {
        form.__poBound = true;

        form.addEventListener("submit", handleAddToCart, true);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * 生成主商品唯一标识（parent key），用于在购物车中关联附加变体
   */
  function generateParentKey() {
    return 'opt-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
  }

  /**
   * 创建 add-to-cart 处理函数（逻辑复用）
   */
  var __poAddingToCart = false; // 防重入标记

  function createAddToCartHandler(root, productId) {
    return function (event) {
      // 必须在第一时间阻止所有默认行为和传播
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // 防重入：如果已经在添加中，忽略重复触发
      if (__poAddingToCart) {

        return;
      }
      __poAddingToCart = true;

      // 获取表单（event.target 可能是 form，也可能是 button）
      var form = event.target;
      if (!form || form.tagName !== "FORM") {
        form = document.querySelector("form[action*='/cart/add']") || document.querySelector("form[action*='/cart']");
      }

      // 生成主商品唯一标识，用于关联附加变体
      var parentKey = generateParentKey();

      // 0. 验证 required 字段是否已填写
      var optSet = root.__po_optionSet;
      var wantExpertPosition = root.__po_wantExpertPosition;
      var wantExpertCheckbox = document.getElementById("po-want-expert-checkbox");
      var isWantExpertChecked = wantExpertCheckbox ? wantExpertCheckbox.checked : false;

      // 清除之前的错误提示
      root.querySelectorAll(".product-options__field--error").forEach(function (el) {
        el.classList.remove("product-options__field--error");
      });
      root.querySelectorAll(".product-options__error-tip").forEach(function (el) {
        el.remove();
      });

      // 收集所有需要验证的 field（封装为可复用的必填校验函数，供 sticky-add-to-cart 等外部调用）
      var fields = (optSet && optSet.fields) ? optSet.fields : [];
      var unifiedItems = root.__po_unifiedItems || [];

      var validateRequired = function () {
        var validationErrors = [];

      fields.forEach(function (field) {
        // 跳过非 required 字段
        if (field.required !== true && field.required !== "true") return;
        // 跳过 label 和 button 类型
        if (field.type === "label" || field.type === "button") return;

        // 找到该 field 在 unifiedItems 中的 position
        var itemPos = null;
        for (var i = 0; i < unifiedItems.length; i++) {
          if (unifiedItems[i].kind === "field" && unifiedItems[i].data && unifiedItems[i].data.id === field.id) {
            itemPos = unifiedItems[i].position;
            break;
          }
        }

        // 如果 want_an_expert checkbox 未选中，跳过 position > wantExpertPosition 的 field
        if (!isWantExpertChecked && wantExpertPosition > -1 && itemPos != null && itemPos > wantExpertPosition) {
          return;
        }

        // 找到对应的 DOM 元素检查是否可见
        var domEl = null;
        for (var j = 0; j < unifiedItems.length; j++) {
          if (unifiedItems[j].kind === "field" && unifiedItems[j].data && unifiedItems[j].data.id === field.id) {
            domEl = unifiedItems[j].__po_domElement;
            break;
          }
        }
        // 如果面板不可见，跳过验证
        if (domEl && (domEl.style.display === "none" || domEl.offsetParent === null)) return;

        // 检查该 field 的输入值
        var inputEl = root.querySelector('[data-po-field-id="' + field.id + '"]');
        if (!inputEl) return;

        var hasValue = false;
        var defaultVal = field.default || "";
        if (field.type === "select") {
          var sv = inputEl.value || "";
          hasValue = sv !== "" && sv !== String(defaultVal) && String(defaultVal).indexOf(sv) === -1;
        } else if (field.type === "radio") {
          var radioChecked = root.querySelector('[data-po-field-id="' + field.id + '"]:checked');
          if (radioChecked) {
            var rv = radioChecked.value || "";
            hasValue = rv !== String(defaultVal) && String(defaultVal).indexOf(rv) === -1;
          }
        } else if (field.type === "checkbox") {
          var checkboxChecked = root.querySelector('[data-po-field-id="' + field.id + '"]:checked');
          if (checkboxChecked) {
            var cv = checkboxChecked.value || "";
            hasValue = cv !== String(defaultVal) && String(defaultVal).indexOf(cv) === -1;
          }
        } else {
          // text, textarea
          var val = inputEl.value.trim();
          // 排除默认占位文字：值等于 default 或是 default 的一部分
          hasValue = val !== "" && val !== String(defaultVal) && String(defaultVal).indexOf(val) === -1;
        }

        if (!hasValue) {
          validationErrors.push({ field: field, domEl: domEl });
        }
      });

      // 如果有验证错误，显示提示并阻止提交
      if (validationErrors.length > 0) {
        __poAddingToCart = false;
        validationErrors.forEach(function (err) {
          if (err.domEl) {
            err.domEl.classList.add("product-options__field--error");
            // 在 field 底部添加红色提示
            var tip = document.createElement("div");
            tip.className = "product-options__error-tip";
            tip.textContent = "Please select or fill in this required field";
            err.domEl.appendChild(tip);
          }
        });
        // 滚动到第一个错误
        if (validationErrors[0].domEl) {
          validationErrors[0].domEl.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return false;
      }
      return true;
      };

      // 暴露给外部（如 sticky-add-to-cart 按钮）做提交前必填校验
      window.__po_validateRequired = validateRequired;

      // 执行必填校验，未通过则中止提交
      if (!validateRequired()) {
        __poAddingToCart = false;
        return;
      }

      // 0.5 确保 globalPriceAdditions 数据最新
      if (typeof window.__po_recalcPrice === "function") {
        window.__po_recalcPrice();

      }

      // 1. 重新收集当前页面上的所有选项选择
      var selectionsArr = collectCurrentSelections(root, optSet);
      // 转为 { fieldId/name: value } 的简单映射
      // - 跳过内部展示面板 "customized result"
      // - 非 required 字段且值等于 field.default 的跳过
      var selections = {};

      // 构建 field 按 label 和 po_id 快速查找
      var fieldsLookup = {};
      var allFields = (optSet && optSet.fields) ? optSet.fields : [];
      allFields.forEach(function (f) {
        if (f.label) fieldsLookup[f.label] = f;
        fieldsLookup["po_" + f.id] = f;
      });

      (selectionsArr || []).forEach(function (s) {
        if (!s || !s.name || s.value === undefined) return;
        // 跳过展示面板
        var nameLower = s.name.toLowerCase();
        if (nameLower === "OR" || nameLower.indexOf("OR") !== -1) return;

        // 如果值等于 field.default 或是 default 的一部分，跳过不发送（视为用户未输入）
        var matchedField = fieldsLookup[s.name];
        if (matchedField) {
          var defaultVal = matchedField.default || "";
          var trimmedVal = String(s.value).trim();
          if (trimmedVal === String(defaultVal) || String(defaultVal).indexOf(trimmedVal) !== -1) return;

          // 收集该 field 选中项关联的 variant_id
          var inputEl = root.querySelector('[data-po-field-id="' + matchedField.id + '"]');
          var choiceVid = null;
          if (inputEl) {
            var fType = inputEl.getAttribute("data-po-field-type");
            if (fType === "select") {
              var selOpt = inputEl.options[inputEl.selectedIndex] || null;
              if (selOpt) {
                var varAttr = selOpt.getAttribute("data-po-variants");
                var varObj = varAttr ? JSON.parse(varAttr) : null;
                choiceVid = varObj && varObj.vid ? varObj.vid : null;
              }
            } else if (fType === "radio") {
              var checkedRadio = root.querySelector('[data-po-field-id="' + matchedField.id + '"]:checked');
              if (checkedRadio) {
                var rVarAttr = checkedRadio.getAttribute("data-po-variants");
                var rVarObj = rVarAttr ? JSON.parse(rVarAttr) : null;
                choiceVid = rVarObj && rVarObj.vid ? rVarObj.vid : null;
              }
            } else if (fType === "checkbox") {
              var checkedBoxes = root.querySelectorAll('[data-po-field-id="' + matchedField.id + '"]:checked');
              var vids = [];
              checkedBoxes.forEach(function (cb) {
                var cVarAttr = cb.getAttribute("data-po-variants");
                var cVarObj = cVarAttr ? JSON.parse(cVarAttr) : null;
                if (cVarObj && cVarObj.vid) vids.push(cVarObj.vid);
              });
              if (vids.length > 0) choiceVid = vids.join(",");
            }
          }
          if (choiceVid != null) {
            selections["_" + s.name + "_variant_id"] = String(choiceVid);
          }
        }

        selections[s.name] = s.value;
      });
      // 将 3D 定制选择注入 selections（作为独立 cart properties）
      // global3DSelections 的值已包含价格标签（如 "Brushed + Transparent Copper [ +$50.00 ]"），
      // 无须再从 globalPriceAdditions.options 重复注入加价条目
      Object.keys(global3DSelections || {}).forEach(function (key) {
        selections[key] = global3DSelections[key];
      });

      // 将 3D 定制截图 URL 写入订单属性（下划线前缀：购物车/结账页不显示，但仍随订单带上）
      if (globalCanvasUrl) {
        selections['_globalCanvasUrl'] = globalCanvasUrl;
      }
      // 同时追加 3D 颜色/材质信息（内部使用，以 _ 前缀）
      if (current3DSelections.material) {
        selections["_3d_material"] = current3DSelections.material;
      }
      Object.keys(current3DSelections.colors || {}).forEach(function (part) {
        selections["_3d_color_" + part] = current3DSelections.colors[part];
      });

      // 2. 收集 extra variant ids（去重），并校验有效性，跳过无效变体
      var extraVariantIds = [];
      var extraVidSeen = {};

      // 构建当前商品可用 variant id 集合，用于校验加价选项 vid 是否有效
      var availableVariantIds = {};
      if (optSet && optSet.variants && Array.isArray(optSet.variants)) {
        optSet.variants.forEach(function (v) {
          if (v && v.id != null) availableVariantIds[parseInt(v.id, 10)] = true;
        });
      }

      globalPriceAdditions.options.forEach(function (opt) {
        if (opt.variants && opt.variants.vid) {
          var vid = opt.variants.vid;
          var vidStr = String(vid);
          var vidNum = parseInt(vidStr, 10);
          if (isNaN(vidNum)) {
            console.warn("[TPO] Skipping extra option with non-numeric vid:", opt.label || opt, vid);
            return;
          }
          // 如果是 gid:// 格式，尝试提取纯数字
          if (vidStr.indexOf("gid://") === 0) {
            var parts = vidStr.split("/");
            vidNum = parseInt(parts[parts.length - 1], 10);
            if (isNaN(vidNum)) {
              console.warn("[TPO] Skipping extra option with invalid gid vid:", opt.label || opt, vid);
              return;
            }
          }
          // 去重：同一个 vid 只添加一次
          if (extraVidSeen[vidNum]) {
            return;
          }
          extraVidSeen[vidNum] = true;

          // 校验：加价选项的 vid 必须属于当前商品的可用变体，否则跳过（避免整单 add 失败）
          if (availableVariantIds && Object.keys(availableVariantIds).length > 0 && !availableVariantIds[vidNum]) {
            console.warn("[TPO] Skipping extra option with invalid/missing variant id:", opt.label || opt, vidNum);
            return;
          }

          extraVariantIds.push(vidNum);
        } else {
          // 加价 option 没有有效 vid：custom color 常见原因为 custom_color_vid 为空
          if (opt.source === "3d-custom-color") {
            console.warn("[TPO][AddToCart] Custom color option skipped: missing/invalid custom_color_vid (label:", opt.label, ", extraPrice:", opt.extraPrice, ")");
          } else {
            console.warn("[TPO][AddToCart] Extra option skipped: no valid variants.vid (label:", opt.label, ")");
          }
        }
      });
      // console.log("[TPO][AddToCart] globalPriceAdditions.options:", JSON.stringify(globalPriceAdditions.options));
      // console.log("[TPO][AddToCart] extraVariantIds (after validation):", JSON.stringify(extraVariantIds));
      var ccOpts = (globalPriceAdditions.options || []).filter(function (o) { return o.source === "3d-custom-color"; });
      // console.log("[TPO][AddToCart] custom color options:", JSON.stringify(ccOpts), "| count:", ccOpts.length);

      // 3. 构建 formData（从表单或手动构建）
      var formData;
      if (form) {
        formData = new FormData(form);
      } else {
        formData = new FormData();
      }

      // 确保 variant id 存在（兼容 input 和 select）
      var mainVariantEl = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
      var mainVariantId = mainVariantEl ? mainVariantEl.value : "";
      if (!mainVariantId) {
        mainVariantId = root.getAttribute("data-variant-id") || root.getAttribute("data-product-id") || "";
      }

      // ===== 根据 3D 设计摘要内容 + variant-slide 选择状态，决定提交使用的变体 ID =====
      var slidesRoot = document.getElementById('variant-slides-root');

      // 判断是否存在 3D 设计摘要（通过 canvas_url 和 design-summary 容器判断）
      var dsContainer = document.querySelector('.design-summary[data-po-field-type="custom_label"]');
      var hasDesignSummary = !!(globalCanvasUrl && dsContainer && dsContainer.innerHTML.trim());

      if (hasDesignSummary) {
        // Case 1: 存在 3D 设计摘要 → 使用 base_var_id 作为变体 ID
        var fallbackVid = root.__po_baseVarId;
        if (fallbackVid) {

          mainVariantId = fallbackVid;
        } else {

        }
      } else {
        // Case 2: 无设计摘要
        var selectedSlide = slidesRoot ? slidesRoot.querySelector('.variant-slide-item.is-selected') : null;
        if (selectedSlide) {
          // variant-slide 有选中项 → 使用选中 slide 的 variant-id
          var slideVariantId = selectedSlide.getAttribute('data-variant-id');
          if (slideVariantId && String(slideVariantId).trim() !== "") {

            mainVariantId = slideVariantId;
          } else {

          }
        }
      }

      // ===== 无配置变体 / 变体缺失保护 =====
      // 若 mainVariantId 为空，或不属于当前商品可用变体集合（如误取到 product_id），
      // 则回退到第一个可用变体 id，保证无配置变体产品也能正常加购
      var firstAvailableVid = null;
      var availableVidList = Object.keys(availableVariantIds);
      if (availableVidList.length > 0) {
        firstAvailableVid = parseInt(availableVidList[0], 10);
      }

      var mainVidNum = parseInt(String(mainVariantId), 10);
      if (isNaN(mainVidNum) || (availableVidList.length > 0 && !availableVariantIds[mainVidNum])) {
        if (firstAvailableVid != null) {
          console.warn("[TPO] mainVariantId invalid/empty, falling back to first available variant:", mainVariantId, "→", firstAvailableVid);
          mainVariantId = firstAvailableVid;
        } else {
          console.warn("[TPO] mainVariantId invalid and no available variants found:", mainVariantId);
        }
      }

      // 确保 formData 中使用正确的 variant id（覆盖表单原有的 id，如 base_var_id 回退场景）
      if (mainVariantId) {
        formData.set("id", mainVariantId);
      }
      formData.append("quantity", formData.get("quantity") || "1");
      var cartQty = formData.get("quantity") || "1";

      // 把 selections 写入 properties
      Object.keys(selections).forEach(function (key) {
        formData.append("properties[" + key + "]", selections[key]);
      });

      // 屏蔽 Easify App 的同步逻辑（如果该函数已定义，将其设为空函数）
      if (window.easifyHandleUpdateCartWithAddonProduct) {
        window.easifyHandleUpdateCartWithAddonProduct = function() {
          // console.log("[TPO] Blocked Easify original sync to prevent auto-delete");
          return Promise.resolve();
        };
      }

      // 主商品打上 _tpo_parent_identifier 标记
      formData.append("properties[_tpo_parent_identifier]", parentKey);






      // 4. 原子批量提交：主商品 + 加价商品一次性加入购物车
      // 先快照当前购物车（line item key 集合），用于失败时回滚，保证“严格全部成功才算成功”
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (snapshotCart) {
          var snapshotKeys = (snapshotCart.items || []).map(function (it) { return it.key; });

          // 主商品 item：复用已构建好的 formData，转换为 items 数组所需对象格式
          var mainItem = poFormDataToItem(formData);
          mainItem.id = mainVariantId;
          mainItem.quantity = parseInt(cartQty, 10) || 1;
          // TPO: prevent Easify from injecting Custom Option companions
          if (!mainItem.properties) mainItem.properties = {};
          mainItem.properties["_noeasify"] = "1";

          // 加价商品 item（复用 tpo 关联属性）
          var metaById = {};
          extraVariantIds.forEach(function (vid) {
            metaById[vid] = {
              "_tpo_type_id": "tpo-extra-option",
              "_tpo_parent_identifier": parentKey,
              "_tpo_linked_product_id": productId,
              "_tpo_main_product_id": productId,
              "_tpo_options_summary": JSON.stringify(selections),
              "_noeasify": "1",
            };
          });

          var extraItems = extraVariantIds.map(function (vid) {
            return { id: vid, quantity: parseInt(cartQty, 10) || 1, properties: metaById[vid] };
          });

          var allItems = [mainItem].concat(extraItems);
          // console.log("[TPO][AddToCart] submitting allItems ids:", JSON.stringify(allItems.map(function (i) { return i.id; })));
          // console.log("[TPO][AddToCart] mainItem.properties (3D selections):", JSON.stringify(mainItem.properties));

          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: allItems }),
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (data) {
                  throw new Error(data.description || "Bulk add to cart failed");
                });
              }
              return res.json();
            })
            .then(function (cartJson) {

              __poAddingToCart = false;
              // 统一走全局 rvrnAfterAddToCart：发送 add2cart + 刷新小购物车 + 打开抽屉（不跳 /cart）
              // [FIX] optSet 可能为 undefined（无配置变体的产品不会执行 renderOptions），做兜底避免回调崩溃
              window.rvrnAfterAddToCart({
                sendWheel: true,
                selections: selections,
                optSetFields: optSet && optSet.fields ? optSet.fields : [],
                productId: productId,
                cartQty: cartQty
              });
            })
            .catch(function (err) {
              // 失败回滚：清除本次可能部分加入购物车的商品（主商品 + 加价商品）
              // [DIAG] 暴露真实错误，便于定位 add 失败原因
              console.error("[TPO AddToCart Error]", {
                message: err && err.message,
                mainVariantId: mainVariantId,
                extraVariantIds: extraVariantIds,
                allItems: allItems,
              });

              return poRollbackCart(snapshotKeys, mainVariantId, extraVariantIds).then(function () {
                __poAddingToCart = false;
                alert("Failed to add to cart. Please try again later.");
              }, function (rbErr) {

                __poAddingToCart = false;
                alert("Failed to add to cart. Please try again later.");
              });
            });
        });
    };
  }

  /**
   * 绑定 Add to Cart 表单提交事件
   */
  function bindAddToCart(form, root, productId) {
    var handler = createAddToCartHandler(root, productId);
    // 使用 capture phase 确保在 Shopify 原生 handler 之前执行
    form.addEventListener("submit", handler, true);
    form.__poBound = true;

  }

  function attachPriceAndProperties(root, optionSet) {
    var extraPriceEl = root.querySelector(
      ".product-options__extra-price",
    );
    if (!extraPriceEl) {

      return;
    }

    // 将 recalcPrice 暴露到外部，供联动脚本使用
    window.__po_recalcPrice = recalcPrice;

    function recalcPrice() {
      var total = 0;
      var inputs = root.querySelectorAll("[data-po-field-id]");

      // 收集当前选项中的 option-field 加价，更新 globalPriceAdditions
      var optionFieldEntries = [];

      inputs.forEach(function (input) {
        if (!isElementVisible(input)) {
          return;
        }

        var type = input.getAttribute("data-po-field-type");
        var fieldId = input.getAttribute("data-po-field-id");

        if (type === "select") {
          if (!input.value) return;
          var selectedOption =
            input.options[input.selectedIndex] || null;
          if (!selectedOption) return;
          var extraAttr =
            selectedOption.getAttribute("data-po-extra-price");
          var extra = extraAttr ? parseFloat(extraAttr) : 0;
          if (!isNaN(extra)) total += extra;
          if (extra > 0) {
            var label = (selectedOption.textContent || "").replace(/\s*\(\+.*\)/, "").trim();
            var varAttr = selectedOption.getAttribute("data-po-variants");
            var variants = varAttr ? JSON.parse(varAttr) : null;
            if (!variants || !variants.vid) {

            }
            optionFieldEntries.push({
              source: "option-field",
              label: label || fieldId,
              extraPrice: extra,
              variants: variants
            });
          }
          return;
        }

        var extraAttr =
          input.getAttribute("data-po-extra-price");
        var extra = extraAttr ? parseFloat(extraAttr) : 0;
        if (isNaN(extra)) extra = 0;

        if (type === "text" || type === "textarea") {
          var hasContent = input.value && input.value.trim() !== "";

          // 从元素自身属性读取 variants（渲染时已写入，子字段会包含 vid=parentChoiceId）
          var varAttr = input.getAttribute("data-po-variants");
          var variants = null;
          try { variants = varAttr ? JSON.parse(varAttr) : null; } catch (e) {}

          // add_personal-engravings：只有当前值与默认值互不为子集时才计加价
          var engravingsShouldCharge = true;
          if (fieldId === "add_personal-engravings") {
            var defaultVal = input.getAttribute("data-po-default-value") || "";
            var curVal = (input.value || "").replace(/\s*\[\+\$[\d.]+\]\s*$/, "").trim();
            defaultVal = defaultVal.trim();
            if (curVal.indexOf(defaultVal) !== -1 || defaultVal.indexOf(curVal) !== -1) {
              engravingsShouldCharge = false;

            }
          }

          if (variants && variants.vid) {
            // ========== 子字段：有 data-po-variants，直接使用 ==========
            if (hasContent && extra > 0 && engravingsShouldCharge) {
              total += extra;
              optionFieldEntries.push({
                source: "option-field",
                label: fieldId + " (child)",
                extraPrice: extra,
                variants: variants
              });
            }


          } else {
            // ========== 非子字段：无 variant 关联 ==========
            if (hasContent && engravingsShouldCharge) {
              total += extra;
              if (extra > 0) {
              }
            }
          }
        } else if (type === "radio") {
          if (input.checked) {
            total += extra;
            if (extra > 0) {
              var rLabel = input.parentNode ? (input.parentNode.textContent || "").replace(/\s*\(\+.*\)/, "").trim() : fieldId;
              var rVarAttr = input.getAttribute("data-po-variants");
              var rVariants = rVarAttr ? JSON.parse(rVarAttr) : null;
              if (!rVariants || !rVariants.vid) {

              }
              optionFieldEntries.push({
                source: "option-field",
                label: rLabel || fieldId,
                extraPrice: extra,
                variants: rVariants
              });
            }
          }
        } else if (type === "checkbox") {
          if (input.checked) {
            total += extra;
            if (extra > 0) {
              var cLabel = input.parentNode ? (input.parentNode.textContent || "").replace(/\s*\(\+.*\)/, "").trim() : fieldId;
              var cVarAttr = input.getAttribute("data-po-variants");
              var cVariants = cVarAttr ? JSON.parse(cVarAttr) : null;
              if (!cVariants || !cVariants.vid) {

              }
              optionFieldEntries.push({
                source: "option-field",
                label: cLabel || fieldId,
                extraPrice: extra,
                variants: cVariants
              });
            }
          }
        }
      });

      // 更新 globalPriceAdditions：保留非 option-field 条目，替换 option-field 条目
      globalPriceAdditions.options = globalPriceAdditions.options.filter(function (opt) {
        return opt.source !== "option-field";
      }).concat(optionFieldEntries);

      // 汇总前，检查所有 optionFieldEntries 的 vid 情况
      var missingVidCount = 0;
      var withVidCount = 0;
      optionFieldEntries.forEach(function (entry) {
        if (entry.variants && entry.variants.vid) {
          withVidCount++;
        } else if (entry.extraPrice > 0) {
          missingVidCount++;
        }
      });
      if (missingVidCount > 0) {

      }

      // 从 globalPriceAdditions 汇总最终价格
      var additionsTotal = 0;
      globalPriceAdditions.options.forEach(function (opt) {

        additionsTotal += opt.extraPrice || 0;
      });


      total = additionsTotal;
      extraPriceEl.textContent =
        "ADDITIONAL PRICE：$" + total.toFixed(2);
      extraPriceEl.setAttribute(
        "data-po-extra-total",
        String(total),
      );
    }

    root.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.getAttribute) return;

      var typeAttr = target.getAttribute("data-po-field-type");
      var fieldId = target.getAttribute("data-po-field-id");
      var choiceId = target.getAttribute("data-po-choice-id");


      // 单选：控制子 group 展开
      if (typeAttr === "radio") {
        if (!fieldId || !choiceId) {
          recalcPrice();
          return;
        }

        var allGroups = root.querySelectorAll(
          '[data-po-group-for-field="' + fieldId + '"]',
        );

        allGroups.forEach(function (g) {
          g.style.display = "none";
          resetGroupInputs(g);
        });

        if (target.checked) {
          var group = root.querySelector(
            '[data-po-group-for-field="' +
              fieldId +
              '"][data-po-group-for-choice="' +
              choiceId +
              '"]',
          );
          if (group) group.style.display = "block";
        }
      }

      // 下拉：控制子 group 展开
      if (typeAttr === "select") {
        if (!fieldId) {
          recalcPrice();
          return;
        }

        var selectedOption =
          target.options[target.selectedIndex] || null;
        if (!selectedOption) {
          recalcPrice();
          return;
        }

        var choiceIdSel =
          selectedOption.getAttribute("data-po-choice-id") ||
          selectedOption.value;


        var allGroupsSel = root.querySelectorAll(
          '[data-po-group-for-field="' + fieldId + '"]',
        );

        allGroupsSel.forEach(function (g) {
          g.style.display = "none";
          resetGroupInputs(g);
        });

        if (choiceIdSel) {
          var groupSel = root.querySelector(
            '[data-po-group-for-field="' +
              fieldId +
              '"][data-po-group-for-choice="' +
              choiceIdSel +
              '"]',
          );
          if (groupSel) groupSel.style.display = "block";
        }
      }

      // text/textarea：add_personal-engravings 在 change 时追加 [+$xx.xx] 后缀并重算价格
      if (fieldId === "add_personal-engravings" && (typeAttr === "text" || typeAttr === "textarea")) {
        processPersonalEngravingsChange(target);
      } else if (typeAttr !== "text" && typeAttr !== "textarea") {
        recalcPrice();
      }
    });

    // add_personal-engravings change 时：追加/清除 [+$xx.xx] 价格后缀、粗体，并重算价格
    // extraPrice 和 variant.vid 直接从 text input 自身属性读取（渲染时已写入）
    function processPersonalEngravingsChange(target) {
      var val = target.value.trim();
      var isDefaultStyle = target.classList.contains("product-options__default-text");

      var extraPriceAttr = target.getAttribute("data-po-extra-price");
      var extraPrice = extraPriceAttr ? parseFloat(extraPriceAttr) : 0;
      if (isNaN(extraPrice)) extraPrice = 0;

      if (!val || isDefaultStyle) {
        target.value = target.value.replace(/\s*\[\+\$[\d.]+\]\s*$/, "");
        target.style.fontWeight = "";
      } else if (extraPrice > 0) {
        var stripped = target.value.replace(/\s*\[\+\$[\d.]+\]\s*$/, "");
        target.value = stripped + " [+$" + extraPrice.toFixed(2) + "]";
        target.classList.remove("product-options__default-text");
        target.style.fontWeight = "bold";
      } else {
        target.value = target.value.replace(/\s*\[\+\$[\d.]+\]\s*$/, "");
        target.style.fontWeight = "";
        target.classList.remove("product-options__default-text");
      }

      recalcPrice();
    }

    // input 事件：排除 add_personal-engravings（由 change 处理，避免每键都重算）
    root.addEventListener("input", function (e) {
      var target = e.target;
      var fieldId = target && target.getAttribute ? target.getAttribute("data-po-field-id") : null;
      if (fieldId === "add_personal-engravings") return;
      recalcPrice();
    });

    // add_personal-engravings 聚焦时：剥离 [+$xx.xx] 后缀，恢复可编辑状态
    root.addEventListener("focus", function (e) {
      var target = e.target;
      var fieldId = target && target.getAttribute ? target.getAttribute("data-po-field-id") : null;
      if (fieldId !== "add_personal-engravings") return;
      target.value = target.value.replace(/\s*\[\+\$[\d.]+\]\s*$/, "");
      target.style.fontWeight = "";
    }, true);

    recalcPrice();
  }

  // ===== variant-slides 辅助函数（由 product-options.js 动态渲染，不再依赖 Liquid 模板）=====

  function escapeHTML(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function getVariantImageUrl(imageOrString, size) {
    if (!imageOrString) return '';
    var url = typeof imageOrString === 'string' ? imageOrString : (imageOrString.src || '');
    if (!url) return '';
    if (size && url.indexOf('_' + size) === -1) {
      url = url.replace(/(\.[^.]+)(\?|$)/, '_' + size + '$1$2');
    }
    return url;
  }

  function getVariantImageAlt(imageOrString) {
    if (!imageOrString || typeof imageOrString === 'string') return '';
    return imageOrString.alt || '';
  }

  var __po_vSlidesCSSinjected = false;
  function injectVariantSlidesCSS() {
    if (__po_vSlidesCSSinjected) return;
    __po_vSlidesCSSinjected = true;
    var style = document.createElement('style');
    style.id = 'variant-slides-po-css';
    style.textContent = ".variant-slides-section{margin-bottom:16px}.variant-slides-header{display:flex;align-items:center;gap:4px;margin-bottom:8px;font-size:14px;font-weight:600;color:#ffffff}.variant-slides-selected{color:#64748b}.variant-slides-wrapper{position:relative;display:flex;align-items:center;gap:0}.variant-slides-track{display:flex !important;flex-direction:row !important;flex-wrap:wrap !important;gap:8px;overflow-x:visible;scroll-behavior:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;padding:10px 0;width:100%}.variant-slide-item{flex-shrink:0;position:relative;display:flex;align-items:center;justify-content:center;gap:0;padding:3px;border:1.5px solid rgba(255,255,255,0.3);border-radius:0;cursor:pointer;background:transparent;transition:all 0.2s ease;user-select:none;overflow:visible}.variant-slide-item:hover{border-color:rgba(255,255,255,0.6);background:rgba(255,255,255,0.08);z-index:5}.variant-slide-item.is-selected{border:2px solid #000000;background:transparent;border-radius:0}.variant-slide-item.is-sold-out{opacity:0.35;cursor:not-allowed}.variant-slide-item.is-sold-out:hover{border-color:rgba(255,255,255,0.3);background:transparent}.variant-slide-image{width:84px;height:84px;border-radius:6px;object-fit:cover;flex-shrink:0;background:rgba(255,255,255,0.05);transition:transform 0.25s ease}.variant-slide-item:hover .variant-slide-image{transform:scale(1.12)}.variant-slide-value{position:absolute;bottom:calc(100% + 6px);left:50%;transform:translateX(-50%);padding:4px 10px;border-radius:4px;background:rgba(0,0,0,0.85);color:#ffffff;font-size:12px;font-weight:500;white-space:nowrap;pointer-events:none;opacity:0;visibility:hidden;transition:opacity 0.15s ease,visibility 0.15s ease;z-index:10}.variant-slide-value::after{content:'';position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:rgba(0,0,0,0.85)}.variant-slide-item:hover .variant-slide-value{opacity:1;visibility:visible}.variant-slide-item--no-image{padding:6px 14px}.variant-slide-item--no-image .variant-slide-value{position:static;transform:none;opacity:1;visibility:visible;background:none;color:inherit;padding:0;font-size:13px;font-weight:500}.variant-slide-item--no-image .variant-slide-value::after{display:none}.variant-slide-item.is-sold-out.variant-slide-item--no-image .variant-slide-value{text-decoration:line-through}.variant-slide-item.is-selected.variant-slide-item--no-image .variant-slide-value{color:#000000}.product-options .variant-slides-header{color:#121212}.product-options .variant-slide-item{border-color:rgba(0,0,0,0.2)}.product-options .variant-slide-item:hover{border-color:rgba(0,0,0,0.4);background:rgba(0,0,0,0.04)}.product-options .variant-slide-item.is-selected{border:2px solid #000000;background:transparent;border-radius:0}.product-options .variant-slide-item.is-sold-out{opacity:0.4}.product-options .variant-slide-item.is-sold-out:hover{border-color:rgba(0,0,0,0.2);background:transparent}.product-options .variant-slide-image{background:rgba(0,0,0,0.04)}.product-options .variant-slide-item--no-image .variant-slide-value{color:#121212}.product-options .variant-slide-item.is-selected.variant-slide-item--no-image .variant-slide-value{color:#121212}";
    document.head.appendChild(style);
  }

  function generateVariantSlidesHTML(product) {
    if (!product || !product.options || !product.variants || product.variants.length === 0) return '';
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') return '';

    var html = '';
    var options = product.options || [];
    var variants = product.variants || [];
3
    options.forEach(function (option, optionIndex) {
      var uniqueValues = [];
      var seen = {};
      variants.forEach(function (variant) {
        var val = variant.options[optionIndex];
        if (val == null) return;
        var key = '|||' + val + '|||';
        if (!seen[key]) {
          seen[key] = true;

          var anyAvailable = variants.some(function (v) {
            return v.options[optionIndex] === val && v.available;
          });

          var imgUrl = '';
          var imgAlt = '';
          for (var vi = 0; vi < variants.length; vi++) {
            var v = variants[vi];
            if (v.options[optionIndex] === val) {
              imgUrl = getVariantImageUrl(v.image || v.featured_image, '200x');
              imgAlt = getVariantImageAlt(v.image || v.featured_image);
              if (imgUrl) break;
            }
          }
          if (!imgUrl && product.featured_image) {
            imgUrl = getVariantImageUrl(product.featured_image, '200x');
            imgAlt = getVariantImageAlt(product.featured_image);
          }

          var variantId = '';
          for (var vj = 0; vj < variants.length; vj++) {
            if (variants[vj].options[optionIndex] === val) {
              variantId = variants[vj].id;
              break;
            }
          }

          uniqueValues.push({
            value: val,
            available: anyAvailable,
            imageUrl: imgUrl,
            imageAlt: imgAlt,
            variantId: variantId
          });
        }
      });

      html += '<div class="variant-slides-section" data-option-index="' + optionIndex + '">';
      html += '<div class="variant-slides-header">';
      html += '<span class="variant-slides-title">' + escapeHTML(option) + ': </span>';
      html += '<span class="variant-slides-selected" data-option-selected-label="' + optionIndex + '"></span>';
      html += '</div>';
      html += '<div class="variant-slides-wrapper" data-option-wrapper="' + optionIndex + '">';
      html += '<div class="variant-slides-track" data-slides-track="' + optionIndex + '" style="display:flex;flex-wrap:wrap;">';

      uniqueValues.forEach(function (item) {
        var itemClass = 'variant-slide-item';
        if (!item.available) itemClass += ' is-sold-out';
        if (!item.imageUrl) itemClass += ' variant-slide-item--no-image';

        html += '<div class="' + itemClass + '"';
        html += ' data-option-index="' + optionIndex + '"';
        html += ' data-value="' + escapeHTML(item.value) + '"';
        html += ' data-available="' + item.available + '"';
        html += ' data-variant-id="' + item.variantId + '">';
        if (item.imageUrl) {
          html += '<img class="variant-slide-image" src="' + item.imageUrl + '"';
          html += ' alt="' + escapeHTML(item.imageAlt || item.value) + '"';
          html += ' width="84" height="84" loading="lazy" />';
        }
        html += '<span class="variant-slide-value">' + escapeHTML(item.value) + '</span>';
        html += '</div>';
      });

      html += '</div></div></div>';
    });

    return html;
  }

  function loadVariantSlidesJS() {
    if (document.getElementById('variant-slides-po-js')) return;
    if (!__po_assetBase) return;
    var script = document.createElement('script');
    script.id = 'variant-slides-po-js';
    script.src = __po_assetBase + 'variant-slides.js';
    script.defer = true;
    document.body.appendChild(script);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductOptions);
  } else {
    initProductOptions();
  }

})();
